/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AresResponse {
	/** @deprecated */
	address?: string;
	legalName?: string;
	address1?: string;
	address2?: string;
	city?: string;
	postalCode?: string;
	regNumber?: string;
	vatId?: string;
	regRecord: string;
	vatRegistered: boolean;
}

export interface AccountCreateParamsDto {
	/** @maxLength 100 */
	email: string;
	/** @maxLength 50 */
	firstName: string;
	/** @maxLength 50 */
	lastName: string;
	/** @maxLength 25 */
	phone?: string;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	legalName?: string;
	/** @maxLength 100 */
	address?: string;
	/** @maxLength 100 */
	city?: string;
	/** @maxLength 20 */
	postalCode?: string;
	countryId?: number;
	languageId: number;
	reqSource?: 1 | 2 | 3;
	reqVersion?: string;
}

export interface AccountCreateResultDto {
	accountId: string;
}

export interface AccountRegisterParamsDto {
	/** @maxLength 100 */
	password: string;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 50 */
	firstName: string;
	/** @maxLength 50 */
	lastName: string;
	/** @maxLength 25 */
	phone?: string;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	legalName?: string;
	/** @maxLength 100 */
	address?: string;
	/** @maxLength 100 */
	city?: string;
	/** @maxLength 20 */
	postalCode?: string;
	countryId?: number;
	languageId: number;
	reqSource?: 1 | 2 | 3;
	reqVersion?: string;
}

export interface AccountRegisterResultDto {
	ok: boolean;
	error?: string;
}

export interface AccountSendResetEmailParams {
	/** @maxLength 100 */
	email: string;
}

export interface OkResult {
	ok: boolean;
}

export interface AccountSetPasswordParams {
	/** @maxLength 100 */
	accessCode: string;
	/** @maxLength 100 */
	newPassword: string;
}

export interface AccountVerifyEmailBodyDto {
	/** @maxLength 100 */
	accessCode: string;
}

export interface AccountInformationResult {
	firstLogin: boolean;
	accountId: string;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 50 */
	firstName: string;
	/** @maxLength 50 */
	lastName: string;
	/** @maxLength 25 */
	phone?: string;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	legalName?: string;
	/** @maxLength 100 */
	address?: string;
	/** @maxLength 100 */
	city?: string;
	/** @maxLength 20 */
	postalCode?: string;
	countryId?: number;
	languageId: number;
}

export interface AccountChangePasswordParams {
	/** @maxLength 100 */
	oldPassword: string;
	/** @maxLength 100 */
	newPassword: string;
}

export interface AccountSetDataParams {
	accountId: string;
	/** @maxLength 50 */
	firstName: string;
	/** @maxLength 50 */
	lastName: string;
	/** @maxLength 25 */
	phone?: string;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	legalName?: string;
	/** @maxLength 100 */
	address?: string;
	/** @maxLength 100 */
	city?: string;
	/** @maxLength 20 */
	postalCode?: string;
	countryId?: number;
	languageId: number;
}

export interface AccountEventsResultEventDto {
	eventId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description: string;
	/** @maxLength 100 */
	place: string;
	placeInfo?: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @format date-time */
	showFrom: string;
	/** @format date-time */
	showTo: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorEventCardBackground?: string;
	/** @minLength 8 */
	colorEventCardName?: string;
	/** @minLength 8 */
	colorEventCardText?: string;
	/** @minLength 8 */
	colorEventCardHighlight?: string;
	/** @minLength 8 */
	colorEventCardLink?: string;
	/** @minLength 8 */
	colorEventCardSubtitle?: string;
	/** @minLength 8 */
	colorTicketCardBackground?: string;
	/** @minLength 8 */
	colorTicketCardText?: string;
	/** @minLength 8 */
	colorTicketCardIcon?: string;
	/** @maxLength 255 */
	logoFileName?: string;
	typeId: number;
	longTerm: boolean;
}

export interface AccountEventsResultOrganizerDto {
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	slug: string;
	/** @maxLength 100 */
	legalName: string;
	/** @maxLength 100 */
	address1: string;
	/** @maxLength 100 */
	address2?: string;
	/** @maxLength 100 */
	city: string;
	/** @maxLength 20 */
	postalCode: string;
	countryId: number;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	taxId?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	contactPhone: string;
	/** @maxLength 100 */
	contactEmail: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorEventCardBackground: string;
	/** @minLength 8 */
	colorEventCardName: string;
	/** @minLength 8 */
	colorEventCardText: string;
	/** @minLength 8 */
	colorEventCardHighlight: string;
	/** @minLength 8 */
	colorEventCardLink: string;
	/** @minLength 8 */
	colorEventCardSubtitle: string;
	/** @minLength 8 */
	colorTicketCardBackground: string;
	/** @minLength 8 */
	colorTicketCardText: string;
	/** @minLength 8 */
	colorTicketCardIcon: string;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface AccountEventsResultDto {
	event: AccountEventsResultEventDto;
	organizer: AccountEventsResultOrganizerDto;
}

export interface AccountTicketsResultDto {
	orderId: string;
	eventId: string;
	ticketId: string;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 100 */
	qrCode: string;
	/** @maxLength 100 */
	name?: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardBackground?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardText?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardIcon?: string;
}

export interface AccountTicketsByEventResultDto {
	orderId: string;
	ticketId: string;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 100 */
	qrCode: string;
	/** @maxLength 100 */
	name?: string;
	ticketTypeId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardBackground?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardText?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardIcon?: string;
}

export interface AccountChipsByEventResultDto {
	redeemed: boolean;
	/** @min 0 */
	voucherAmount: number;
	name?: string;
	/** @minLength 11 */
	chipId: string;
}

export interface AccountOrdersResultDto {
	currency: string;
	eventName: string;
	organizerId: string;
	organizerName: string;
	orderId: string;
	/** @min 1 */
	orderNumber: number;
	/** @format date-time */
	created: string;
	/** @min 1 */
	amount: number;
	/** @min 1 */
	paidAmount: number;
	/** @format date-time */
	bookedUntil?: string;
	/** @format date-time */
	paid?: string;
	/** @format date-time */
	canceled?: string;
	eventId: string;
}

export interface AccountLoginParamsDto {
	/** @maxLength 100 */
	password: string;
	/** @maxLength 100 */
	email: string;
}

export interface TokenResultDto {
	token: string;
}

export interface AccountLoginWithAccessCodeParamsDto {
	/** @maxLength 100 */
	accessCode: string;
}

export interface AccountFavoriteBandProfilesResultDto {
	bandId: string;
}

export interface AccountFavoriteBandProfilesInEventResultDto {
	bandId: string;
}

export interface AccountFavoriteBandProfilesParamsDto {
	bandId: string;
}

export interface BandByIdResultDto {
	profileExists: boolean;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	descriptionShort: string;
}

export interface BandGalleriesResultDto {
	galleryId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
}

export interface BandGalleryByIdResultDto {
	/** @maxLength 100 */
	namePub: string;
	description?: string;
}

export interface BandGalleryImagesResultDto {
	imageId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @maxLength 100 */
	fileName: string;
}

export interface BandPerformersResultDto {
	profileExists: boolean;
	performerId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	displayOrder: number;
}

export interface BandProfileByIdResultDto {
	logoFileName: string;
	mainImageFileName: string;
	smallImageFileName?: string;
	highlightImageFileName?: string;
	/** @maxLength 100 */
	slug: string;
	logoWidth: number;
	logoHeight: number;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorGalleryBackground: string;
	galleryId?: string;
	/** @maxLength 100 */
	fansEmail?: string;
	/** @maxLength 50 */
	fansPhone?: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	descriptionShort: string;
}

export interface BandProfileBySlugResultDto {
	logoFileName: string;
	mainImageFileName: string;
	smallImageFileName?: string;
	highlightImageFileName?: string;
	bandId: string;
	logoWidth: number;
	logoHeight: number;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorGalleryBackground: string;
	galleryId?: string;
	/** @maxLength 100 */
	fansEmail?: string;
	/** @maxLength 50 */
	fansPhone?: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	descriptionShort: string;
}

export interface BandProfileForListResultDto {
	logoFileName: string;
	mainImageFileName: string;
	smallImageFileName?: string;
	highlightImageFileName?: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @maxLength 100 */
	namePub: string;
	descriptionShort: string;
}

export interface BandProfilesAllResultDto {
	bandId: string;
}

export type VirtualEventCurrency = object;

export interface EventBySlugsResultEventDto {
	/** @minLength 3 */
	currency: string;
	ticketsSet: boolean;
	entryExists: boolean;
	virtualCurrency?: VirtualEventCurrency;
	eventId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description: string;
	/** @maxLength 100 */
	place: string;
	placeInfo?: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @min -1 */
	peopleLimit: number;
	/** @minLength 8 */
	colorEventCardBackground?: string;
	/** @minLength 8 */
	colorEventCardName?: string;
	/** @minLength 8 */
	colorEventCardText?: string;
	/** @minLength 8 */
	colorEventCardHighlight?: string;
	/** @minLength 8 */
	colorEventCardLink?: string;
	/** @minLength 8 */
	colorEventCardSubtitle?: string;
	/** @minLength 8 */
	colorTicketCardBackground?: string;
	/** @minLength 8 */
	colorTicketCardText?: string;
	/** @minLength 8 */
	colorTicketCardIcon?: string;
	/** @maxLength 255 */
	logoFileName?: string;
	longTerm: boolean;
	typeId: number;
}

export interface EventBySlugsResultOrganizerDto {
	organizerId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	legalName: string;
	/** @maxLength 100 */
	address1: string;
	/** @maxLength 100 */
	address2?: string;
	/** @maxLength 100 */
	city: string;
	/** @maxLength 20 */
	postalCode: string;
	countryId: number;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	taxId?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	contactPhone: string;
	/** @maxLength 100 */
	contactEmail: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorEventCardBackground: string;
	/** @minLength 8 */
	colorEventCardName: string;
	/** @minLength 8 */
	colorEventCardText: string;
	/** @minLength 8 */
	colorEventCardHighlight: string;
	/** @minLength 8 */
	colorEventCardLink: string;
	/** @minLength 8 */
	colorEventCardSubtitle: string;
	/** @minLength 8 */
	colorTicketCardBackground: string;
	/** @minLength 8 */
	colorTicketCardText: string;
	/** @minLength 8 */
	colorTicketCardIcon: string;
	/** @min 1 */
	logoWidth?: number;
	/** @min 1 */
	logoHeight?: number;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface EventBySlugsResultDto {
	event: EventBySlugsResultEventDto;
	organizer: EventBySlugsResultOrganizerDto;
}

export interface EventByIdResultEventDto {
	/** @minLength 3 */
	currency: string;
	ticketsSet: boolean;
	entryExists: boolean;
	virtualCurrency?: VirtualEventCurrency;
	/** @maxLength 100 */
	slug: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description: string;
	/** @maxLength 100 */
	place: string;
	placeInfo?: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @min -1 */
	peopleLimit: number;
	/** @minLength 8 */
	colorEventCardBackground?: string;
	/** @minLength 8 */
	colorEventCardName?: string;
	/** @minLength 8 */
	colorEventCardText?: string;
	/** @minLength 8 */
	colorEventCardHighlight?: string;
	/** @minLength 8 */
	colorEventCardLink?: string;
	/** @minLength 8 */
	colorEventCardSubtitle?: string;
	/** @minLength 8 */
	colorTicketCardBackground?: string;
	/** @minLength 8 */
	colorTicketCardText?: string;
	/** @minLength 8 */
	colorTicketCardIcon?: string;
	/** @maxLength 255 */
	logoFileName?: string;
	longTerm: boolean;
	typeId: number;
}

export interface EventByIdResultOrganizerDto {
	organizerId: string;
	/** @maxLength 100 */
	slug: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	legalName: string;
	/** @maxLength 100 */
	address1: string;
	/** @maxLength 100 */
	address2?: string;
	/** @maxLength 100 */
	city: string;
	/** @maxLength 20 */
	postalCode: string;
	countryId: number;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	taxId?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	contactPhone: string;
	/** @maxLength 100 */
	contactEmail: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorEventCardBackground: string;
	/** @minLength 8 */
	colorEventCardName: string;
	/** @minLength 8 */
	colorEventCardText: string;
	/** @minLength 8 */
	colorEventCardHighlight: string;
	/** @minLength 8 */
	colorEventCardLink: string;
	/** @minLength 8 */
	colorEventCardSubtitle: string;
	/** @minLength 8 */
	colorTicketCardBackground: string;
	/** @minLength 8 */
	colorTicketCardText: string;
	/** @minLength 8 */
	colorTicketCardIcon: string;
	/** @min 1 */
	logoWidth?: number;
	/** @min 1 */
	logoHeight?: number;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface EventByIdResultDto {
	event: EventByIdResultEventDto;
	organizer: EventByIdResultOrganizerDto;
}

export interface EventGroupBySlugResultDto {
	eventGroupId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description?: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorCardBackground: string;
	/** @minLength 8 */
	colorCardName: string;
	/** @minLength 8 */
	colorCardText: string;
	/** @minLength 8 */
	colorCardHighlight: string;
	/** @minLength 8 */
	colorCardLink: string;
	/** @minLength 8 */
	colorCardSubtitle: string;
	/** @min 1 */
	logoWidth?: number;
	/** @min 1 */
	logoHeight?: number;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface EventGroupEventsResultDto {
	/** @maxLength 100 */
	orgSlug: string;
	eventId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description: string;
	/** @maxLength 100 */
	place: string;
	placeInfo?: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorEventCardBackground?: string;
	/** @minLength 8 */
	colorEventCardName?: string;
	/** @minLength 8 */
	colorEventCardText?: string;
	/** @minLength 8 */
	colorEventCardHighlight?: string;
	/** @minLength 8 */
	colorEventCardLink?: string;
	/** @minLength 8 */
	colorEventCardSubtitle?: string;
	/** @minLength 8 */
	colorTicketCardBackground?: string;
	/** @minLength 8 */
	colorTicketCardText?: string;
	/** @minLength 8 */
	colorTicketCardIcon?: string;
	/** @maxLength 255 */
	logoFileName?: string;
	typeId: number;
	longTerm: boolean;
}

export interface EventGroupsByAllResultDto {
	eventCount: number;
	eventGroupId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description?: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorCardBackground: string;
	/** @minLength 8 */
	colorCardName: string;
	/** @minLength 8 */
	colorCardText: string;
	/** @minLength 8 */
	colorCardHighlight: string;
	/** @minLength 8 */
	colorCardLink: string;
	/** @minLength 8 */
	colorCardSubtitle: string;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface EventsAllResultEventDto {
	ticketsSet: boolean;
	eventId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description: string;
	/** @maxLength 100 */
	place: string;
	placeInfo?: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorEventCardBackground?: string;
	/** @minLength 8 */
	colorEventCardName?: string;
	/** @minLength 8 */
	colorEventCardText?: string;
	/** @minLength 8 */
	colorEventCardHighlight?: string;
	/** @minLength 8 */
	colorEventCardLink?: string;
	/** @minLength 8 */
	colorEventCardSubtitle?: string;
	/** @minLength 8 */
	colorTicketCardBackground?: string;
	/** @minLength 8 */
	colorTicketCardText?: string;
	/** @minLength 8 */
	colorTicketCardIcon?: string;
	/** @maxLength 255 */
	logoFileName?: string;
	typeId: number;
	longTerm: boolean;
}

export interface EventsAllResultOrganizerDto {
	organizerId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	slug: string;
	/** @maxLength 100 */
	legalName: string;
	/** @maxLength 100 */
	address1: string;
	/** @maxLength 100 */
	address2?: string;
	/** @maxLength 100 */
	city: string;
	/** @maxLength 20 */
	postalCode: string;
	countryId: number;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	taxId?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	contactPhone: string;
	/** @maxLength 100 */
	contactEmail: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorEventCardBackground: string;
	/** @minLength 8 */
	colorEventCardName: string;
	/** @minLength 8 */
	colorEventCardText: string;
	/** @minLength 8 */
	colorEventCardHighlight: string;
	/** @minLength 8 */
	colorEventCardLink: string;
	/** @minLength 8 */
	colorEventCardSubtitle: string;
	/** @minLength 8 */
	colorTicketCardBackground: string;
	/** @minLength 8 */
	colorTicketCardText: string;
	/** @minLength 8 */
	colorTicketCardIcon: string;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface EventsAllResultDto {
	event: EventsAllResultEventDto;
	organizer: EventsAllResultOrganizerDto;
}

export interface EventsByOrganizerResultDto {
	organizerSlug: string;
	locationVenue: EventsByOrganizerLocationVenueDto | null;
	saleInfo: EventsByOrganizerSaleInfoDto;
	saleStatus: 0 | 1 | 2 | 3;
	name: string;
	eventId: string;
	/** @maxLength 100 */
	slug: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	openInfo?: string;
	typeId: number;
	/** @maxLength 100 */
	place: string;
	regionId: number;
}

export interface EventBandsResultDto {
	bandId: string;
	/** @maxLength 100 */
	namePub: string;
}

export interface EventEntriesResultDto {
	productExists: boolean;
	entryId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @minLength 8 */
	colorText?: string;
	/** @minLength 8 */
	colorBackground?: string;
	/** @minLength 8 */
	colorHighlight?: string;
	stageId?: string;
}

export interface EventEntriesWithProductsResultDto {
	stageNamePub?: string;
	entryId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @minLength 8 */
	colorText?: string;
	/** @minLength 8 */
	colorBackground?: string;
	/** @minLength 8 */
	colorHighlight?: string;
	stageId?: string;
}

export interface EventMainBandsResultDto {
	profileExists: boolean;
	bandId: string;
}

export interface EventMainPerformersResultDto {
	profileExists: boolean;
	performerId: string;
}

export interface EventPerformersResultDto {
	performerId: string;
	/** @maxLength 100 */
	namePub: string;
}

export interface EventStagesResultDto {
	stageId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	/** @minLength 8 */
	colorText?: string;
	/** @minLength 8 */
	colorBackground?: string;
	galleryId?: string;
	displayOrder: number;
}

export interface EventPaymentMethodsResultDto {
	paymentMethodId: number;
}

export interface FindEventSectorsResultDto {
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	label: string;
	/** @maxLength 20 */
	tag: string;
}

export interface FindEventVenueResultDto {
	/** @maxLength 100 */
	namePub: string;
	drawing: string;
}

export interface GalleryImagesResultDto {
	/** @min 1 */
	displayOrder: number;
	imageId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @maxLength 100 */
	fileName: string;
}

export interface GalleryByIdResultDto {
	/** @maxLength 100 */
	namePub: string;
	description?: string;
}

export interface OrderByIdExtraOrderDto {
	orderId: string;
	orderNumber: number;
	/** @format date-time */
	created: string;
	amount: number;
	paidAmount: number;
	/** @format date-time */
	bookedUntil: string | null;
	/** @format date-time */
	paid: string | null;
	/** @format date-time */
	canceled: string | null;
	paymentMethodId: number;
}

export interface OrderByIdResultDto {
	eventName: string;
	organizerId: string;
	organizerName: string;
	currency: string;
	accountCurrencyId?: number;
	extraOrder?: OrderByIdExtraOrderDto;
	eventId: string;
	orderNumber: number;
	/** @format date-time */
	created: string;
	/** @min 0 */
	amount: number;
	/** @min 0 */
	paidAmount: number;
	/** @format date-time */
	bookedUntil?: string;
	/** @format date-time */
	paid?: string;
	/** @format date-time */
	canceled?: string;
	paymentMethodId: number;
}

export interface OrderCancelResultDto {
	ok: boolean;
}

export interface OrderCheckResultDto {
	email: string;
	paid: boolean;
	cancelled: boolean;
	paymentMethodId: number;
}

export interface OrderCreateChip {
	/** @min 0 */
	amount: number;
}

export interface OrderCreateExtraProduct {
	ticketProductId: string;
	/** @min 1 */
	count: number;
	/** @maxLength 100 */
	optionalText?: string;
	chips: OrderCreateChip[];
}

export interface OrderCreateTicket {
	ticketId: string;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 100 */
	name?: string;
	extraProducts: OrderCreateExtraProduct[];
	chips: OrderCreateChip[];
	ticketCouponId?: string;
	userData?: object;
}

export interface OrderCreateParamsDto {
	tickets: OrderCreateTicket[];
	/** @maxLength 100 */
	email: string;
	/** @maxLength 50 */
	firstName: string;
	/** @maxLength 50 */
	lastName: string;
	/** @maxLength 25 */
	phone?: string;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	legalName?: string;
	/** @maxLength 100 */
	address?: string;
	/** @maxLength 100 */
	city?: string;
	/** @maxLength 20 */
	postalCode?: string;
	countryId?: number;
	/** @maxLength 100 */
	passwordSalt?: string;
	/** @maxLength 100 */
	passwordHash?: string;
	languageId: number;
	eventId: string;
	paymentMethodId: number;
	reqSource?: 1 | 4 | 5;
	reqVersion?: string;
}

export interface OrderCreateResultDto {
	orderId: string;
}

export interface AccountNewParams {
	/** @maxLength 100 */
	email: string;
	/** @maxLength 50 */
	firstName: string;
	/** @maxLength 50 */
	lastName: string;
	/** @maxLength 25 */
	phone?: string;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	legalName?: string;
	/** @maxLength 100 */
	address?: string;
	/** @maxLength 100 */
	city?: string;
	/** @maxLength 20 */
	postalCode?: string;
	countryId?: number;
	/** @maxLength 100 */
	passwordSalt?: string;
	/** @maxLength 100 */
	passwordHash?: string;
	languageId: number;
}

export interface OrderCreateV2ChipDto {
	productItemId: string;
	/** @min 0 */
	amount: number;
}

export interface OrderCreateV2BodyTicketExtraProductDto {
	chips: OrderCreateV2ChipDto[];
	ticketProductId: string;
	/** @min 1 */
	count: number;
	optionalText?: string;
}

export interface OrderCreateV2BodyTicketDto {
	_ticketId: string;
	chips: OrderCreateV2ChipDto[];
	extraProducts: OrderCreateV2BodyTicketExtraProductDto[];
	ticketCouponId?: string;
	seatId?: string;
	reservationCrowdId?: string;
	ticketTypeId: string;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 100 */
	name?: string;
	userData?: object;
}

export interface OrderCreateV2BodyExtraOrderContentDto {
	productId: string;
	/** @min 1 */
	count: number;
	ticketIds?: string[];
}

export interface OrderCreateV2BodyDto {
	account: AccountNewParams;
	tickets: OrderCreateV2BodyTicketDto[];
	reservationId?: string;
	/** @default [] */
	benefitCodes: string[];
	extraOrderContents: OrderCreateV2BodyExtraOrderContentDto[];
	eventId: string;
	paymentMethodId: number;
	bankAccountId?: string;
	reqSource?: 1 | 4 | 5;
	reqVersion?: string;
}

export interface OrderCreateExtraParamsDto {
	ticketId: string;
	extraProducts: OrderCreateExtraProduct[];
	eventId: string;
	paymentMethodId: number;
	reqSource?: 1 | 4 | 5;
	reqVersion?: string;
}

export interface OrderCreateCreditParamsDto {
	/** @minLength 11 */
	chipId: string;
	/** @min 1 */
	amount: number;
	eventId: string;
	paymentMethodId: number;
	reqSource?: 1 | 4 | 5;
	reqVersion?: string;
}

export interface OrderCreateCreditFromCodeBodyDto {
	account: AccountNewParams;
	tickets: OrderCreateCreditFromCodeBodyTicketDto[];
	eventId: string;
	paymentMethodId: number;
	bankAccountId?: string;
	reqSource?: 1 | 4 | 5;
	reqVersion?: string;
}

export interface OrderStatusResultDto {
	canceled: boolean;
	booked: boolean;
	paid: boolean;
	paymentMethodId: number;
}

export interface OrderReceiptsResultDto {
	orgReceiptLogoUrl?: string;
	currency: string;
	receiptId: string;
	orderNumber: number;
	receiptNumber: number;
	paymentMethodId: number;
	issueDate: string;
	vatDate: string;
	/** @maxLength 100 */
	orgLegalName: string;
	/** @maxLength 100 */
	orgAddress1: string;
	/** @maxLength 100 */
	orgAddress2?: string;
	/** @maxLength 100 */
	orgCity: string;
	/** @maxLength 20 */
	orgPostalCode: string;
	orgCountryId: number;
	/** @maxLength 25 */
	orgRegNumber?: string;
	/** @maxLength 25 */
	orgTaxId?: string;
	/** @maxLength 25 */
	orgVatId?: string;
	/** @maxLength 50 */
	accFirstName: string;
	/** @maxLength 50 */
	accLastName: string;
	/** @maxLength 25 */
	accRegNumber?: string;
	/** @maxLength 25 */
	accVatId?: string;
	/** @maxLength 100 */
	accLegalName?: string;
	/** @maxLength 100 */
	accAddress?: string;
	/** @maxLength 100 */
	accCity?: string;
	/** @maxLength 20 */
	accPostalCode?: string;
	accCountryId?: number;
	taxDocument: boolean;
	currencyId: number;
}

export interface ExtraOrderReceiptsProductResultDto {
	/** @maxLength 100 */
	name: string;
	/** @min 0 */
	vatRate: number;
	price: number;
	count: number;
}

export interface ExtraOrderReceiptsVatResultDto {
	vatRate: number;
	price: number;
}

export interface ExtraOrderReceiptsReceiptResultDto {
	orgReceiptLogoUrl?: string;
	products: ExtraOrderReceiptsProductResultDto[];
	vatTable: ExtraOrderReceiptsVatResultDto[];
	receiptId: string;
	orderNumber: number;
	receiptNumber: number;
	paymentMethodId: number;
	issueDate: string;
	vatDate: string | null;
	/** @maxLength 100 */
	orgLegalName: string;
	/** @maxLength 100 */
	orgAddress1: string;
	/** @maxLength 100 */
	orgAddress2: string | null;
	/** @maxLength 100 */
	orgCity: string;
	/** @maxLength 20 */
	orgPostalCode: string;
	orgCountryId: number;
	/** @maxLength 25 */
	orgRegNumber: string | null;
	/** @maxLength 25 */
	orgTaxId: string | null;
	/** @maxLength 25 */
	orgVatId: string | null;
	/** @maxLength 50 */
	accFirstName: string;
	/** @maxLength 50 */
	accLastName: string;
	/** @maxLength 25 */
	accRegNumber: string | null;
	/** @maxLength 25 */
	accVatId: string | null;
	/** @maxLength 100 */
	accLegalName: string | null;
	/** @maxLength 100 */
	accAddress: string | null;
	/** @maxLength 100 */
	accCity: string | null;
	/** @maxLength 20 */
	accPostalCode: string | null;
	accCountryId: number | null;
	taxDocument: boolean;
	currencyId: number;
}

export interface OrderReceiptsV2ResultDto {
	receipts: ExtraOrderReceiptsReceiptResultDto[];
}

export interface ExtraOrderReceiptsResultDto {
	receipts: ExtraOrderReceiptsReceiptResultDto[];
}

export interface OrderTicketsResultDto {
	ticketId: string;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 100 */
	name?: string;
	/** @maxLength 100 */
	namePub: string;
	/** @min 0 */
	price: number;
	/** @pattern COLOR_REGEX */
	colorTicketCardBackground?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardText?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardIcon?: string;
	active: boolean;
}

export interface OrderVouchersResultDto {
	active: boolean;
	/** @min 1 */
	amount: number;
}

export interface OrderContentResultExtraProductDto {
	namePub: string;
	ticketId: string;
	/** @min 1 */
	count: number;
	/** @min 0 */
	total: number;
}

export interface OrderContentResultExtraVoucherDto {
	ticketId: string;
	/** @min 1 */
	amount: number;
}

export interface OrderPaidResultTicketDto {
	namePub: string;
	/** @min 1 */
	price: number;
	name?: string;
	email: string;
	extraProducts: OrderContentResultExtraProductDto[];
	vouchers: OrderContentResultExtraVoucherDto[];
	/** @pattern COLOR_REGEX */
	colorTicketCardBackground?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardText?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardIcon?: string;
}

export interface OrderContentResultDto {
	tickets: OrderPaidResultTicketDto[];
	extraProducts: OrderContentResultExtraProductDto[];
	extraVouchers: OrderContentResultExtraVoucherDto[];
}

export interface FindBankTransactionResultDto {
	bankOrderNumber: number;
	/** @min 1 */
	amount: number;
	currencyId: number;
	/** @maxLength 6 */
	prefix?: string;
	/** @maxLength 10 */
	number?: string;
	/** @maxLength 4 */
	bank?: string;
	/** @maxLength 11 */
	bic?: string;
	/** @maxLength 34 */
	iban?: string;
}

export interface OrganizerBySlugResultDto {
	organizerId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	legalName: string;
	/** @maxLength 100 */
	address1: string;
	/** @maxLength 100 */
	address2?: string;
	/** @maxLength 100 */
	city: string;
	/** @maxLength 20 */
	postalCode: string;
	countryId: number;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	taxId?: string;
	/** @maxLength 25 */
	vatId?: string;
	/** @maxLength 100 */
	contactPhone: string;
	/** @maxLength 100 */
	contactEmail: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorEventCardBackground: string;
	/** @minLength 8 */
	colorEventCardName: string;
	/** @minLength 8 */
	colorEventCardText: string;
	/** @minLength 8 */
	colorEventCardHighlight: string;
	/** @minLength 8 */
	colorEventCardLink: string;
	/** @minLength 8 */
	colorEventCardSubtitle: string;
	/** @minLength 8 */
	colorTicketCardBackground: string;
	/** @minLength 8 */
	colorTicketCardText: string;
	/** @minLength 8 */
	colorTicketCardIcon: string;
	/** @min 1 */
	logoWidth?: number;
	/** @min 1 */
	logoHeight?: number;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface OrganizerEventGroupsResultDto {
	/** @min 0 */
	eventCount: number;
	eventGroupId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description?: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorCardBackground: string;
	/** @minLength 8 */
	colorCardName: string;
	/** @minLength 8 */
	colorCardText: string;
	/** @minLength 8 */
	colorCardHighlight: string;
	/** @minLength 8 */
	colorCardLink: string;
	/** @minLength 8 */
	colorCardSubtitle: string;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface OrganizersAllResultDto {
	/** @min 0 */
	eventCount: number;
	organizerId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorEventCardBackground: string;
	/** @minLength 8 */
	colorEventCardName: string;
	/** @minLength 8 */
	colorEventCardText: string;
	/** @minLength 8 */
	colorEventCardHighlight: string;
	/** @minLength 8 */
	colorEventCardLink: string;
	/** @minLength 8 */
	colorEventCardSubtitle: string;
	/** @minLength 8 */
	colorTicketCardBackground: string;
	/** @maxLength 255 */
	logoFileName?: string;
}

export interface AccountFavoritePerformerProfilesResultDto {
	performerId: string;
}

export interface AccountFavoritePerformerProfilesInEventResultDto {
	performerId: string;
}

export interface AccountFavoritePerformerProfilesParamsDto {
	performerId: string;
}

export interface PerformerByIdResultDto {
	profileExists: boolean;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	descriptionShort: string;
}

export interface PerformerBandsResultDto {
	profileExists: boolean;
	bandId: string;
}

export interface PerformerGalleriesResultDto {
	galleryId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
}

export interface PerformerGalleryByIdResultDto {
	/** @maxLength 100 */
	namePub: string;
	description?: string;
}

export interface PerformerGalleryImagesResultDto {
	imageId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @maxLength 100 */
	fileName: string;
}

export interface PerformerProfileByIdResultDto {
	profileImageFileName: string;
	logoFileName?: string;
	highlightImageFileName?: string;
	/** @maxLength 100 */
	slug: string;
	logoWidth?: number;
	logoHeight?: number;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorGalleryBackground: string;
	galleryId?: string;
	/** @maxLength 100 */
	fansEmail?: string;
	/** @maxLength 50 */
	fansPhone?: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	descriptionShort: string;
}

export interface PerformerProfileBySlugResultDto {
	profileImageFileName: string;
	logoFileName?: string;
	highlightImageFileName?: string;
	performerId: string;
	logoWidth?: number;
	logoHeight?: number;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorGalleryBackground: string;
	galleryId?: string;
	/** @maxLength 100 */
	fansEmail?: string;
	/** @maxLength 50 */
	fansPhone?: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	descriptionShort: string;
}

export interface PerformerProfileForListResultDto {
	profileImageFileName: string;
	highlightImageFileName?: string;
	/** @maxLength 100 */
	slug: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	/** @minLength 8 */
	colorGalleryBackground: string;
	galleryId?: string;
	/** @maxLength 100 */
	namePub: string;
}

export interface PerformerProfilesAllResultDto {
	performerId: string;
}

export interface ProductGroupResultDto {
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	galleryId?: string;
}

export interface ProductGroupVariantsResultDto {
	variantId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	controlTypeId: number;
	/** @min 1 */
	displayOrder: number;
	galleryId?: string;
}

export interface VariantValuesResultDto {
	/** @min 0 */
	valueId: number;
	/** @maxLength 100 */
	namePub: string;
	selected: boolean;
}

export interface TicketProductVariantValuesResultDto {
	variantId: string;
	/** @min 0 */
	valueId: number;
}

export interface StageEntriesResultDto {
	entryId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	/** @format date-time */
	dateFrom: string;
	/** @format date-time */
	dateTo: string;
	/** @minLength 8 */
	colorText?: string;
	/** @minLength 8 */
	colorBackground?: string;
	/** @minLength 8 */
	colorHighlight?: string;
}

export interface EntryBandsResultDto {
	profileExists: boolean;
	bandId: string;
	displayOrder: number;
	main: boolean;
}

export interface EntryPerformersResultDto {
	profileExists: boolean;
	performerId: string;
	displayOrder: number;
	main: boolean;
}

export interface EntryProductsResultDto {
	ticketProductId: string;
	/** @min 1 */
	displayOrder: number;
	/** @maxLength 100 */
	namePub: string;
	/** @min 0 */
	price: number;
	productGroupId?: string;
}

export interface ReceiptProductsResultDto {
	/** @maxLength 100 */
	name: string;
	/** @min 0 */
	vatRate: number;
	/** @min 1 */
	price: number;
	/** @min 1 */
	count: number;
}

export interface ReceiptVatTableResultDto {
	/** @min 0 */
	vatRate: number;
	/** @min 1 */
	price: number;
}

export interface CreateReservationReservationBodyDto {
	eventId: string;
}

export interface CreateReservationReservationResultDto {
	reservationId: string;
	/** @format date-time */
	created: string;
	/** @format date-time */
	reservedUntil?: string;
}

export interface ErrorText {
	errorText: string;
}

export interface CreateReservationReservationCrowdBodyDto {
	replaceReservationCrowdId?: string;
	reservationId: string;
	crowdId: string;
}

export interface CreateReservationReservationCrowdResultDto {
	reservationCrowdId: string;
}

export interface CreateReservationReservationSeatBodyDto {
	replaceSeatId?: string;
	reservationId: string;
	seatId: string;
}

export interface CreateReservationReservationSeatResultDto {
	seatId: string;
}

export interface FindOneReservationSectorResultDto {
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @maxLength 100 */
	label: string;
	/** @maxLength 20 */
	tag: string;
	drawing: string;
}

export interface FindAllSectorSeatsResultDto {
	seatId: string;
	categoryId: string;
	/** @maxLength 100 */
	fullName: string;
	/** @maxLength 10 */
	label: string;
	/** @maxLength 25 */
	seatRow: string;
	/** @min 1 */
	place: number;
	/** @min 0 */
	posX: number;
	/** @min 0 */
	posY: number;
	/**
	 * @min 0
	 * @max 360
	 */
	rotation: number;
	seatTypeId: number;
}

export interface TicketTypesByEventResultDto {
	/** @min 0 */
	ticketsAvailable: number;
	ticketTypeId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @min 1 */
	displayOrder: number;
	/** @min 0 */
	price: number;
	/** @min -1 */
	ticketLimitOrder: number;
	/** @min 0 */
	creditLimit: number;
	/** @pattern COLOR_REGEX */
	colorTicketCardBackground?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardText?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardIcon?: string;
}

export interface TicketTypeByIdResultDto {
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @min 0 */
	price: number;
	/** @min 0 */
	creditLimit: number;
	/** @pattern COLOR_REGEX */
	colorTicketCardBackground?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardText?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardIcon?: string;
	userData?: object;
}

export interface TicketTypesExtraProductsResultDto {
	productsAvailable: number;
	ticketProductId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @min 0 */
	price: number;
	productGroupId?: string;
	/** @min 1 */
	displayOrder: number;
	galleryId?: string;
	optionalTextRegex?: string;
	/** @min 1 */
	quantityLimit: number;
}

export interface TicketContentItemTypesResultDto {
	itemTypeId: number;
	quantity: number;
}

export interface ProductItemTypesResultDto {
	itemTypeId: number;
	quantity: number;
}

export interface ChipCreditLimitResultDto {
	/** @min 0 */
	creditLimit: number;
}

export interface TicketExtraProductsResultDto {
	productsAvailable: number;
	ticketProductId: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @min 0 */
	price: number;
	productGroupId?: string;
	/** @min 1 */
	displayOrder: number;
	galleryId?: string;
	optionalTextRegex?: string;
	/** @min 1 */
	quantityLimit: number;
}

export interface TicketCouponResultDto {
	evSlug: string;
	orgSlug: string;
	ticketCouponId: string;
	ticketTypeId: string;
	credit: number;
	/** @maxLength 100 */
	email?: string;
	/** @maxLength 50 */
	firstName?: string;
	/** @maxLength 50 */
	lastName?: string;
	eventId: string;
}

export interface TicketSupercouponResultDto {
	evSlug?: string;
	orgSlug?: string;
	ticketSupercouponId: string;
	/** @maxLength 50 */
	coupon?: string;
	errorText: string;
}

export interface TicketSupercouponTicketTypesResultDto {
	evNamePub: string;
	/** @format date-time */
	evDateFrom: string;
	/** @format date-time */
	evDateTo: string;
	currencyId: number;
	ticketTypeId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @min 0 */
	price: number;
	/** @min 1 */
	displayOrder: number;
	eventId: string;
}

export interface TicketSupercouponRedeemBodyDto {
	ticketSupercouponId: string;
	ticketTypeId: string;
}

export interface TicketSupercouponRedeemResultDto {
	evSlug?: string;
	orgSlug?: string;
	/** @maxLength 50 */
	coupon: string;
}

export interface TicketByIdResultDto {
	eventId: string;
	orderId: string;
	accountId: string;
	ticketTypeId: string;
	active: boolean;
	/** @maxLength 100 */
	email: string;
	/** @maxLength 100 */
	qrCode: string;
	/** @maxLength 100 */
	name?: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardBackground?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardText?: string;
	/** @pattern COLOR_REGEX */
	colorTicketCardIcon?: string;
}

export interface TicketItemsResultDto {
	/** @min 0 */
	total: number;
	/** @min 0 */
	redeemed: number;
	itemTypeId: number;
	/** @maxLength 100 */
	namePub: string;
}

export interface TicketProductsResultDto {
	/** @min 1 */
	count: number;
	/** @min 0 */
	total: number;
	/** @maxLength 100 */
	namePub: string;
}

export interface TicketChipsResultDto {
	/** @min 0 */
	amount: number;
	/** @minLength 11 */
	chipId: string;
}

export interface TicketByCodeResultChipDto {
	/** @minLength 11 */
	chipId: string;
}

export interface TicketByCodeResultDto {
	chips: TicketByCodeResultChipDto[];
	ticketId: string;
	ticketTypeId: string;
	eventId: string;
}

export interface GetEventBySlugsEventColorsDto {
	background: string;
	name: string;
	text: string;
	highlight: string;
	link: string;
	subtitle: string;
}

export interface GetEventBySlugsCurrencyVirtualCurrencyTextsDto {
	few: string;
	many: string;
	one: string;
	other: string;
}

export interface GetEventBySlugsCurrencyVirtualCurrencyDto {
	texts: Record<string, GetEventBySlugsCurrencyVirtualCurrencyTextsDto>;
	rate: number;
	name: string;
}

export interface ExtraCurrencies {
	currencyId: number;
	/** @min 1 */
	rate: number;
}

export interface GetEventBySlugsCurrencyDto {
	baseCurrencyId: number;
	virtualCurrency?: GetEventBySlugsCurrencyVirtualCurrencyDto;
	extraCurrencies: ExtraCurrencies[];
}

export interface GetEventBySlugsSaleInfoDto {
	ticketsSet: boolean;
	/** @format date-time */
	saleFrom?: string;
	/** @format date-time */
	saleTo?: string;
}

export interface FindOneEventPaymentMethodDto {
	paymentMethodId: number;
	displayOrder: number;
}

export interface GetEventBySlugsOrganizerCompanyDto {
	/** @maxLength 100 */
	legalName: string;
	/** @maxLength 100 */
	address1: string;
	/** @maxLength 100 */
	address2?: string;
	/** @maxLength 100 */
	city: string;
	/** @maxLength 20 */
	postalCode: string;
	countryId: number;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	taxId?: string;
	/** @maxLength 25 */
	vatId?: string;
}

export interface GetEventBySlugsOrganizerColorsDto {
	background: string;
	text: string;
}

export interface GetEventBySlugsOrganizerDto {
	name: string;
	company: GetEventBySlugsOrganizerCompanyDto;
	organizerColors: GetEventBySlugsOrganizerColorsDto;
	organizerId: string;
	/** @maxLength 100 */
	slug: string;
	logoUrl?: string;
}

export interface FindOneEventLocationVenueDto {
	venueId: string;
	venueTypeId: number;
	name: string;
	description?: string;
	locPointLocation: number[];
	imageUrl?: string;
}

export interface FindOneEventVenueDto {
	name: string;
}

export interface FindOneEventCategoriesDto {
	categoryId: number;
}

export interface FindOneEventBankAccountDto {
	accountId: string;
	currencyId: number;
}

export interface FindOneEventResultDto {
	eventColors: GetEventBySlugsEventColorsDto;
	currency: GetEventBySlugsCurrencyDto;
	saleInfo?: GetEventBySlugsSaleInfoDto;
	paymentMethods: FindOneEventPaymentMethodDto[];
	organizer: GetEventBySlugsOrganizerDto;
	holderRequired: boolean;
	locationVenue?: FindOneEventLocationVenueDto;
	reservationVenue?: FindOneEventVenueDto;
	categories: FindOneEventCategoriesDto[];
	bankAccounts: FindOneEventBankAccountDto[];
	ticketCompany: GetEventBySlugsOrganizerCompanyDto;
	productCompany: GetEventBySlugsOrganizerCompanyDto;
	headerImageUrl?: string;
	receiptLogoUrl?: string;
	eventId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle?: string;
	description: string;
	/** @maxLength 100 */
	place: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	descriptionMd?: string;
	extraData?: object;
	openInfo?: string;
	logoUrl?: string;
	longTerm: boolean;
	typeId: number;
	/** @maxLength 100 */
	slug: string;
	/** @maxLength 25 */
	fbPixelId?: string;
	/** @maxLength 25 */
	gtmId?: string;
	regionId: number;
}

export interface GetTicketTypesFullTicketTypeGroupDto {
	ticketTypeGroupId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @min 1 */
	displayOrder: number;
	extraData: object | null;
}

export interface GetTicketTypesFullContentItemsDto {
	quantity: number;
	itemTypeId: number;
	productItemId: string;
}

export interface GetTicketTypesFullCategoriesDto {
	categoryId: string;
}

export interface GetTicketTypesFullExtraProductsDto {
	ticketProductId: string;
	/** @min -1 */
	quantityLimit: number;
}

export interface OrgPartnerForTicketTypes {
	logoUrl?: string;
	/** @maxLength 100 */
	namePub: string;
}

export interface GetTicketTypesFullResultDto {
	ticketTypeGroup?: GetTicketTypesFullTicketTypeGroupDto;
	contentItems: GetTicketTypesFullContentItemsDto[];
	ticketsAvailable: number;
	categories: GetTicketTypesFullCategoriesDto[];
	extraProducts: GetTicketTypesFullExtraProductsDto[];
	orgPartner?: OrgPartnerForTicketTypes;
	ticketTypeId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string | null;
	/** @min 1 */
	displayOrder: number;
	/** @min 0 */
	price: number;
	/** @min -1 */
	ticketLimitOrder: number;
	/** @min 0 */
	creditLimit: number;
	/** @min 0 */
	creditMinimum: number;
	userData: object | null;
	extraData: object | null;
}

export interface GetExtraProductsFromEventProductResultDto {
	productId: string;
	productTypeId: number;
	companyId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string;
	/** @min 0 */
	price: number;
	/** @min 1 */
	displayOrder: number;
	extraData: object | null;
	productLimit: number;
}

export interface GetExtraProductsFromEventCompanyResultDto {
	companyId: string;
	/** @maxLength 100 */
	legalName: string;
	/** @maxLength 100 */
	address1: string;
	/** @maxLength 100 */
	address2?: string;
	/** @maxLength 100 */
	city: string;
	/** @maxLength 20 */
	postalCode: string;
	countryId: number;
	/** @maxLength 25 */
	regNumber?: string;
	/** @maxLength 25 */
	taxId?: string;
	/** @maxLength 25 */
	vatId?: string;
}

export interface GetExtraProductsFromEventResultDto {
	products: GetExtraProductsFromEventProductResultDto[];
	companies: GetExtraProductsFromEventCompanyResultDto[];
}

export interface GetEventEventGroupsEventGroupDto {
	eventGroupId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	slug: string;
	/** @maxLength 100 */
	subtitle?: string;
	logoUrl?: string;
}

export interface GetEventEventGroupsResultDto {
	eventGroups: GetEventEventGroupsEventGroupDto[];
}

export interface FindOneCouponTicketTypesDto {
	ticketsAvailable: number;
	categories: GetTicketTypesFullCategoriesDto[];
	colorMobileTicketCardFg: string;
	colorMobileTicketCardBg: string;
	mobileTicketCardLogoUrl?: string;
	contentItems: GetTicketTypesFullContentItemsDto[];
	extraProducts: GetTicketTypesFullExtraProductsDto[];
	originalTicketTypeId?: string;
	ticketTypeGroup?: GetTicketTypesFullTicketTypeGroupDto;
	ticketTypeId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string | null;
	/** @min 1 */
	displayOrder: number;
	/** @min 0 */
	price: number;
	/** @min -1 */
	ticketLimitOrder: number;
	/** @min 0 */
	creditLimit: number;
	/** @min 0 */
	creditMinimum: number;
	userData: object | null;
	/** @format date-time */
	saleFrom: string | null;
	/** @format date-time */
	saleTo: string | null;
	extraData: object | null;
}

export interface FindOneCouponOrgPartnerDto {
	orgPartnerBackgroundColor?: string;
	orgPartnerForegroundColor?: string;
	/** @maxLength 100 */
	namePub: string;
	logoUrl?: string;
}

export interface FindOneCouponResultDto {
	ticketTypes: FindOneCouponTicketTypesDto[];
	orgPartner: FindOneCouponOrgPartnerDto;
}

export interface OrgPartnerTicketType {
	ticketTypeId: string;
	description: string;
}

export interface GetActiveOrgPartnersFromEventResultDto {
	logoUrl?: string;
	ticketTypes: OrgPartnerTicketType[];
	/** @maxLength 100 */
	namePub: string;
	/** @maxLength 100 */
	subtitle: string | null;
	description: string | null;
	/** @maxLength 10 */
	shortCode: string;
}

export interface GetTicketPriceRangeFromEventResultDto {
	minLimit: number;
	maxLimit: number;
}

export interface FindAllTicketTypesFromEventQuickStatsResultDto {
	ticketTypeId: string;
	availableCount: number;
}

export interface FindAllReservationCategoriesFromEventResultDto {
	name: string;
	categoryId: string;
	description?: string;
	/** @minLength 8 */
	color: string;
}

export interface FindOneVenueFromEventSectorsCategoriesDto {
	categoryId: string;
}

export interface FindOneVenueFromEventSectorsDto {
	name: string;
	totalCrowdCount: number;
	totalSeatCount: number;
	capacityLeft: number;
	categories: FindOneVenueFromEventSectorsCategoriesDto[];
	sectorId: string;
	/** @maxLength 100 */
	label: string;
	/** @maxLength 20 */
	tag: string;
	drawing: string;
}

export interface FindOneVenueFromEventResultDto {
	name: string;
	sectors: FindOneVenueFromEventSectorsDto[];
	drawing: string;
}

export interface FindOneTicketByCodeResultTicketChipDto {
	/** @minLength 11 */
	chipId: string;
}

export interface FindOneTicketByCodeResultTicketDto {
	chips: FindOneTicketByCodeResultTicketChipDto[];
	ticketId: string;
	name: string;
	/** @maxLength 100 */
	email: string;
}

export interface FindOneTicketByCodeResultDto {
	ticketType: GetTicketTypesFullResultDto;
	ticket: FindOneTicketByCodeResultTicketDto;
	topupable: boolean;
}

export interface FindAllVisibleEventsSlugsResultDto {
	eventSlug: string;
	organizerSlug: string;
}

export interface FindOneOrderStatusResultDto {
	/** @format date-time */
	paid?: string;
	/** @format date-time */
	canceled?: string;
	/** @format date-time */
	bookedUntil?: string;
}

export interface FindAllVisibleEventGroupsSlugsResultDto {
	/** @maxLength 100 */
	slug: string;
}

export interface GetEventGroupBySlugsEventGroupColorsDto {
	background: string;
	text: string;
	cardBackground: string;
	cardName: string;
	cardText: string;
	cardLink: string;
	cardSubtitle: string;
}

export interface GetEventGroupBySlugResultDto {
	eventGroupColors: GetEventGroupBySlugsEventGroupColorsDto;
	headerImageUrl?: string;
	descriptionMd?: string;
	faviconUrl?: string;
	/** @format date-time */
	saleStart?: string;
	eventGroupId: string;
	name: string;
	description?: string;
	/** @maxLength 100 */
	subtitle?: string;
	logoUrl?: string;
}

export interface FindOrgPartnerByEventGroupSlugResultDto {
	name: string;
	logoUrl?: string;
	badgeColorText?: string;
	badgeColorBackground?: string;
	description: string | null;
	/** @maxLength 10 */
	shortCode: string;
}

export interface GeoJsonGeometryPoint {
	type: 'Point';
	/**
	 * @maxItems 2
	 * @minItems 2
	 */
	coordinates: number[];
}

export interface GetEventGroupVisibleEventsByIdLocationVenueDto {
	locPoint: GeoJsonGeometryPoint;
	venueId: string;
	name: string;
	description?: string;
}

export interface GetEventGroupVisibleEventsByIdSaleInfoDto {
	ticketsSet: boolean;
	/** @format date-time */
	saleFrom?: string;
	/** @format date-time */
	saleTo?: string;
}

export interface GetEventGroupVisibleEventsByIdResultDto {
	organizerSlug: string;
	locationVenue: GetEventGroupVisibleEventsByIdLocationVenueDto;
	saleInfo: GetEventGroupVisibleEventsByIdSaleInfoDto;
	saleStatus: 0 | 1 | 2 | 3;
	eventId: string;
	name: string;
	/** @maxLength 100 */
	slug: string;
	/** @format date-time */
	takesPlaceFrom: string;
	/** @format date-time */
	takesPlaceTo: string;
	openInfo?: string;
	typeId: number;
	/** @maxLength 100 */
	place: string;
	regionId: number;
}

export interface EventsByOrganizerLocationVenueDto {
	name: string;
	locPoint: GeoJsonGeometryPoint;
	venueId: string;
	description?: string;
}

export interface EventsByOrganizerSaleInfoDto {
	ticketsSet: boolean;
	/** @format date-time */
	saleFrom: string | null;
	/** @format date-time */
	saleTo: string | null;
}

export interface CheckDiscountCodeResultDto {
	ticketTypes: FindOneCouponTicketTypesDto[];
	orgPartner: FindOneCouponOrgPartnerDto;
	/** @format date-time */
	redeemedAt: string;
}

export interface FindAllExtraProductsFromTicketTypeProductItemDto {
	/** @min 1 */
	quantity: number;
	itemTypeId: number;
	productItemId: string;
}

export interface FindAllExtraProductsFromTicketTypeProductGalleryImagesDto {
	imageId: string;
	name: string;
	description?: string;
	imageUrl: string;
}

export interface FindAllExtraProductsFromTicketTypeProductGalleryDto {
	images: FindAllExtraProductsFromTicketTypeProductGalleryImagesDto[];
	galleryId: string;
	name: string;
	description?: string;
}

export interface FindAllExtraProductsFromTicketTypeVariantsDto {
	variantId: string;
	/** @min 0 */
	valueId: number;
}

export interface FindAllExtraProductsFromTicketTypeResultDto {
	productsAvailable: number;
	productItems: FindAllExtraProductsFromTicketTypeProductItemDto[];
	gallery?: FindAllExtraProductsFromTicketTypeProductGalleryDto;
	variants: FindAllExtraProductsFromTicketTypeVariantsDto[];
	ticketProductId: string;
	description?: string;
	/** @min 0 */
	price: number;
	/** @min 1 */
	displayOrder: number;
	optionalTextRegex?: string;
	productGroupId?: string;
	name: string;
}

export interface FindAllProductGroupsFromTicketTypeGalleryImagesDto {
	imageId: string;
	name: string;
	description?: string;
	imageUrl: string;
}

export interface FindAllProductGroupsFromTicketTypeGalleryDto {
	images: FindAllProductGroupsFromTicketTypeGalleryImagesDto[];
	galleryId: string;
	name: string;
	description?: string;
}

export interface FindAllProductGroupsFromTicketTypeVariantsGalleryDto {
	images: FindAllProductGroupsFromTicketTypeGalleryImagesDto[];
	galleryId: string;
	name: string;
	description?: string;
}

export interface FindAllProductGroupsFromTicketTypeVariantsValuesDto {
	valueId: number;
	name: string;
	selected: boolean;
	ticketProductId: string;
}

export interface FindAllProductGroupsFromTicketTypeVariantsDto {
	gallery?: FindAllProductGroupsFromTicketTypeVariantsGalleryDto;
	values: FindAllProductGroupsFromTicketTypeVariantsValuesDto[];
	variantId: string;
	name: string;
	description?: string;
	controlTypeId: number;
	/** @min 1 */
	displayOrder: number;
}

export interface FindAllProductGroupsFromTicketTypeResultDto {
	quantityLimit: number;
	gallery?: FindAllProductGroupsFromTicketTypeGalleryDto;
	variants: FindAllProductGroupsFromTicketTypeVariantsDto[];
	productGroupId: string;
	name: string;
	description?: string;
}

export interface GetTicketTypesFullTicketColorsDto {
	background: string;
	text: string;
	icon: string;
}

export interface GetOneTicketTypesFullResultDto {
	ticketTypeGroup?: GetTicketTypesFullTicketTypeGroupDto;
	contentItems: GetTicketTypesFullContentItemsDto[];
	ticketsAvailable: number;
	categories: GetTicketTypesFullCategoriesDto[];
	extraProducts: GetTicketTypesFullExtraProductsDto[];
	orgPartner?: OrgPartnerForTicketTypes;
	ticketTypeId: string;
	/** @maxLength 100 */
	namePub: string;
	description: string | null;
	/** @min 1 */
	displayOrder: number;
	/** @min 0 */
	price: number;
	/** @min -1 */
	ticketLimitOrder: number;
	/** @min 0 */
	creditLimit: number;
	/** @min 0 */
	creditMinimum: number;
	userData: object | null;
	extraData: object | null;
	ticketColors: GetTicketTypesFullTicketColorsDto;
}

export interface FindOneSectorCrowdsDto {
	name: string;
	capacityLeft: number;
	crowdId: string;
	categoryId: string;
	/** @maxLength 20 */
	tag: string;
}

export interface FindOneSectorSeatsPositionDto {
	x: number;
	y: number;
	/**
	 * @min 0
	 * @max 360
	 */
	rotation: number;
}

export interface FindOneSectorSeatsDto {
	capacityLeft: number;
	position: FindOneSectorSeatsPositionDto;
	seatId: string;
	categoryId: string;
	/** @maxLength 100 */
	fullName: string;
	/** @maxLength 25 */
	seatRow: string;
	/** @min 1 */
	place: number;
	seatTypeId: number;
	/** @maxLength 10 */
	label: string;
	unsalable: boolean;
}

export interface FindOneSectorResultDto {
	name: string;
	crowds: FindOneSectorCrowdsDto[];
	seats: FindOneSectorSeatsDto[];
	sectorId: string;
	drawing: string;
}

export interface GetOrderContentsTicketDto {
	ticketTypeName: string;
	ticketTypePrice: number;
	ticketTypeExtraData: object;
	ticketId: string;
	ticketTypeId: string;
	/** @maxLength 100 */
	name?: string;
}

export interface GetOrderContentsProductDto {
	namePub: string;
	productId: string;
	ticketId: string;
	/** @min 0 */
	price: number;
	/** @min 1 */
	count: number;
}

export interface GetOrderContentsCreditVoucherDto {
	/** @minLength 11 */
	chipId: string;
	ticketId: string;
	/** @min 1 */
	amount: number;
}

export interface GetOrderContentsExtraContentsResultDto {
	ticketIds: string[];
	orderContentId: string;
	productId: string;
	/** @min 0 */
	price: number;
	count: number;
	/** @maxLength 100 */
	namePub: string;
	productTypeId: number;
}

export interface GetOrderContentsResultDto {
	tickets: GetOrderContentsTicketDto[];
	products: GetOrderContentsProductDto[];
	creditVouchers: GetOrderContentsCreditVoucherDto[];
	extraContents: GetOrderContentsExtraContentsResultDto[];
}

export interface OrderCreateCreditFromCodeBodyChipDto {
	/** @min 1 */
	amount: number;
	/** @minLength 11 */
	chipId?: string;
}

export interface OrderCreateCreditFromCodeBodyTicketDto {
	chips: OrderCreateCreditFromCodeBodyChipDto[];
	ticketId: string;
}

export interface FindAllVisibleOrganizerSlugsResultDto {
	/** @maxLength 100 */
	slug: string;
}

export interface GetOrganizerBySlugResultDto {
	organizerId: string;
	/** @maxLength 100 */
	namePub: string;
	/** @minLength 8 */
	colorBackground: string;
	/** @minLength 8 */
	colorText: string;
	logoUrl?: string;
}

export interface CreateImageParamsDto {
	file: {
		/** @format binary */
		file?: File;
	};
	/** @maxLength 100 */
	nameInt: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
}

export interface UpdateImageParamsDto {
	/** @maxLength 100 */
	nameInt: string;
	/** @maxLength 100 */
	namePub: string;
	description?: string;
	/** @maxLength 100 */
	fileName: string;
	lastChange: string;
}

import { type LANGUAGE, type REQ_SOURCE } from '@nfctron/nexus-core';
import { type AxiosInstance, type AxiosRequestConfig, type AxiosResponse, type ResponseType } from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
	/** set parameter to `true` for call `securityWorker` for this request */
	secure?: boolean;
	/** request path */
	path: string;
	/** content type of request body */
	type?: ContentType;
	/** query params */
	query?: QueryParamsType;
	/** format of response (i.e. response.json() -> format: "json") */
	format?: ResponseType;
	/** request body */
	body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface NfctronApiParams
	extends Partial<{
		reqSource: REQ_SOURCE;
		version: string;
		locale: string | LANGUAGE;
	}> {}

export interface ApiConfig<SecurityDataType = unknown> {
	securityWorker?: (securityData: SecurityDataType | null) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
	nfctronApiWorker?: (nfctronApiParams: NfctronApiParams) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
	secure?: boolean;
	format?: ResponseType;
	instance: AxiosInstance;
}

export enum ContentType {
	Json = 'application/json',
	FormData = 'multipart/form-data',
	UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
	public instance: AxiosInstance;
	public securityData: SecurityDataType | null = null;
	private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
	public nfctronApiParams: NfctronApiParams | null = null;
	private nfctronApiWorker?: ApiConfig<SecurityDataType>['nfctronApiWorker'];
	private secure?: boolean;
	private format?: ResponseType;

	constructor({ securityWorker, nfctronApiWorker, secure, format, instance }: ApiConfig<SecurityDataType>) {
		this.instance = instance;
		this.secure = secure;
		this.format = format;
		this.securityWorker = securityWorker;
		this.nfctronApiWorker = nfctronApiWorker;
	}

	public setSecurityData = (data: SecurityDataType | null) => {
		this.securityData = data;
	};

	public setNfctronApiParams = (nfctronApiParams: NfctronApiParams) => {
		this.nfctronApiParams = nfctronApiParams;
	};

	private mergeRequestParams(params1: AxiosRequestConfig, params2?: AxiosRequestConfig): AxiosRequestConfig {
		return {
			...this.instance.defaults,
			...params1,
			...(params2 || {}),
			// @ts-ignore
			headers: {
				...(this.instance.defaults.headers || {}),
				...(params1.headers || {}),
				...((params2 && params2.headers) || {}),
			},
		};
	}

	private createFormData(input: Record<string, unknown>): FormData {
		return Object.keys(input || {}).reduce((formData, key) => {
			const property = input[key];
			formData.append(
				key,
				property instanceof Blob ? property : typeof property === 'object' && property !== null ? JSON.stringify(property) : `${property}`,
			);
			return formData;
		}, new FormData());
	}

	public request = async <T = any, _E = any>({
		secure,
		path,
		type,
		query,
		format,
		body,
		...params
	}: FullRequestParams): Promise<AxiosResponse<T>> => {
		const secureParams =
			((typeof secure === 'boolean' ? secure : this.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
		const nfctronApiParams = this.nfctronApiWorker && this.nfctronApiParams ? (await this.nfctronApiWorker(this.nfctronApiParams)) || {} : {};
		const requestParams1 = this.mergeRequestParams(params, secureParams);
		const requestParams = this.mergeRequestParams(requestParams1, nfctronApiParams);
		const responseFormat = (format && this.format) || void 0;

		if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
			requestParams.headers = requestParams.headers ?? {};
			(requestParams.headers.common as any) = { Accept: '*/*' };
			(requestParams.headers.post as any) = {};
			(requestParams.headers.put as any) = {};

			body = this.createFormData(body as Record<string, unknown>);
		}

		return this.instance.request({
			...requestParams,
			headers: {
				...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
				...(requestParams.headers || {}),
			},
			params: query,
			responseType: responseFormat,
			data: body,
			url: path,
		});
	};
}

/**
 * @title NFCtron Pass API
 * @version 0.259.2
 * @license Do not share
 * @baseUrl https://api.staging.nfctron.com/
 * @contact
 *
 * API for communication between NFCtron Pass and NFCtron backend.
 */
export class PassApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
	pass = {
		/**
		 * No description
		 *
		 * @name GetStatus
		 * @request GET:/pass
		 * @response `200` `void`
		 */
		getStatus: {
			id: '/pass',
			request: (params: RequestParams = {}) =>
				this.request<void, any>({
					path: `/pass`,
					method: 'GET',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @name Ares
		 * @request GET:/pass/ares
		 * @response `200` `AresResponse`
		 */
		ares: {
			id: '/pass/ares',
			request: (
				query: {
					/** @maxLength 8 */
					ico: string;
				},
				params: RequestParams = {},
			) =>
				this.request<AresResponse, any>({
					path: `/pass/ares`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @name DebugInfo
		 * @request GET:/pass/debug-info
		 * @response `200` `void`
		 */
		debugInfo: {
			id: '/pass/debug-info',
			request: (params: RequestParams = {}) =>
				this.request<void, any>({
					path: `/pass/debug-info`,
					method: 'GET',
					...params,
				}),
		},
	};
	account = {
		/**
		 * No description
		 *
		 * @tags account
		 * @name Create
		 * @request POST:/pass/account-create
		 * @response `201` `AccountCreateResultDto`
		 */
		create: {
			id: '/pass/account-create',
			request: (data: AccountCreateParamsDto, params: RequestParams = {}) =>
				this.request<AccountCreateResultDto, any>({
					path: `/pass/account-create`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name Register
		 * @request POST:/pass/account-register
		 * @response `201` `AccountRegisterResultDto`
		 */
		register: {
			id: '/pass/account-register',
			request: (data: AccountRegisterParamsDto, params: RequestParams = {}) =>
				this.request<AccountRegisterResultDto, any>({
					path: `/pass/account-register`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountSendResetEmail
		 * @request POST:/pass/account-send-reset-email
		 * @response `201` `OkResult`
		 */
		accountSendResetEmail: {
			id: '/pass/account-send-reset-email',
			request: (data: AccountSendResetEmailParams, params: RequestParams = {}) =>
				this.request<OkResult, any>({
					path: `/pass/account-send-reset-email`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountSetPassword
		 * @request POST:/pass/account-set-password
		 * @response `201` `OkResult`
		 */
		accountSetPassword: {
			id: '/pass/account-set-password',
			request: (data: AccountSetPasswordParams, params: RequestParams = {}) =>
				this.request<OkResult, any>({
					path: `/pass/account-set-password`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountVerifyEmail
		 * @request POST:/pass/account-verify-email
		 * @response `201` `OkResult`
		 */
		accountVerifyEmail: {
			id: '/pass/account-verify-email',
			request: (data: AccountVerifyEmailBodyDto, params: RequestParams = {}) =>
				this.request<OkResult, any>({
					path: `/pass/account-verify-email`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name Account
		 * @request GET:/pass/account
		 * @secure
		 * @response `200` `AccountInformationResult`
		 */
		account: {
			id: '/pass/account',
			request: (
				query: {
					/** @maxLength 100 */
					accessCode: string;
				},
				params: RequestParams = {},
			) =>
				this.request<AccountInformationResult, any>({
					path: `/pass/account`,
					method: 'GET',
					query: query,
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountByToken
		 * @request GET:/pass/account-by-token
		 * @secure
		 * @response `200` `AccountInformationResult`
		 */
		accountByToken: {
			id: '/pass/account-by-token',
			request: (params: RequestParams = {}) =>
				this.request<AccountInformationResult, any>({
					path: `/pass/account-by-token`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountByAccessCode
		 * @request GET:/pass/account-by-access-code
		 * @response `200` `AccountInformationResult`
		 */
		accountByAccessCode: {
			id: '/pass/account-by-access-code',
			request: (
				query: {
					/** @maxLength 100 */
					accessCode: string;
				},
				params: RequestParams = {},
			) =>
				this.request<AccountInformationResult, any>({
					path: `/pass/account-by-access-code`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountChangePassword
		 * @request POST:/pass/account-change-password
		 * @secure
		 * @response `201` `OkResult`
		 */
		accountChangePassword: {
			id: '/pass/account-change-password',
			request: (data: AccountChangePasswordParams, params: RequestParams = {}) =>
				this.request<OkResult, any>({
					path: `/pass/account-change-password`,
					method: 'POST',
					body: data,
					secure: true,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountSetData
		 * @request POST:/pass/account-set-data
		 * @secure
		 * @response `201` `OkResult`
		 */
		accountSetData: {
			id: '/pass/account-set-data',
			request: (data: AccountSetDataParams, params: RequestParams = {}) =>
				this.request<OkResult, any>({
					path: `/pass/account-set-data`,
					method: 'POST',
					body: data,
					secure: true,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountEvents
		 * @request GET:/pass/account-events
		 * @secure
		 * @response `200` `(AccountEventsResultDto)[]`
		 */
		accountEvents: {
			id: '/pass/account-events',
			request: (params: RequestParams = {}) =>
				this.request<AccountEventsResultDto[], any>({
					path: `/pass/account-events`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountTickets
		 * @request GET:/pass/account-tickets
		 * @secure
		 * @response `200` `(AccountTicketsResultDto)[]`
		 */
		accountTickets: {
			id: '/pass/account-tickets',
			request: (params: RequestParams = {}) =>
				this.request<AccountTicketsResultDto[], any>({
					path: `/pass/account-tickets`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountTicketsByEvent
		 * @request GET:/pass/account-tickets-by-event
		 * @secure
		 * @response `200` `(AccountTicketsByEventResultDto)[]`
		 */
		accountTicketsByEvent: {
			id: '/pass/account-tickets-by-event',
			request: (
				query: {
					eventId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<AccountTicketsByEventResultDto[], any>({
					path: `/pass/account-tickets-by-event`,
					method: 'GET',
					query: query,
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountChipsByEvent
		 * @request GET:/pass/account-chips-by-event
		 * @secure
		 * @response `200` `(AccountChipsByEventResultDto)[]`
		 */
		accountChipsByEvent: {
			id: '/pass/account-chips-by-event',
			request: (
				query: {
					eventId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<AccountChipsByEventResultDto[], any>({
					path: `/pass/account-chips-by-event`,
					method: 'GET',
					query: query,
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags account
		 * @name AccountOrders
		 * @request GET:/pass/account-orders
		 * @secure
		 * @response `200` `(AccountOrdersResultDto)[]`
		 */
		accountOrders: {
			id: '/pass/account-orders',
			request: (params: RequestParams = {}) =>
				this.request<AccountOrdersResultDto[], any>({
					path: `/pass/account-orders`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},
	};
	auth = {
		/**
		 * No description
		 *
		 * @tags auth
		 * @name Login
		 * @request POST:/pass/login
		 * @response `201` `TokenResultDto`
		 */
		login: {
			id: '/pass/login',
			request: (data: AccountLoginParamsDto, params: RequestParams = {}) =>
				this.request<TokenResultDto, any>({
					path: `/pass/login`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags auth
		 * @name LoginWithAccessCode
		 * @request POST:/pass/login-with-access-code
		 * @response `201` `TokenResultDto`
		 */
		loginWithAccessCode: {
			id: '/pass/login-with-access-code',
			request: (data: AccountLoginWithAccessCodeParamsDto, params: RequestParams = {}) =>
				this.request<TokenResultDto, any>({
					path: `/pass/login-with-access-code`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},
	};
	band = {
		/**
		 * No description
		 *
		 * @tags band
		 * @name GetAccountFavorite
		 * @request GET:/pass/band/favorite
		 * @secure
		 * @response `200` `(AccountFavoriteBandProfilesResultDto)[]`
		 */
		getAccountFavorite: {
			id: '/pass/band/favorite',
			request: (params: RequestParams = {}) =>
				this.request<AccountFavoriteBandProfilesResultDto[], any>({
					path: `/pass/band/favorite`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name CreateAccountFavorite
		 * @request POST:/pass/band/favorite
		 * @secure
		 * @response `201` `void`
		 */
		createAccountFavorite: {
			id: '/pass/band/favorite',
			request: (data: AccountFavoriteBandProfilesParamsDto, params: RequestParams = {}) =>
				this.request<void, any>({
					path: `/pass/band/favorite`,
					method: 'POST',
					body: data,
					secure: true,
					type: ContentType.Json,
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name DeleteAccountFavorite
		 * @request DELETE:/pass/band/favorite
		 * @secure
		 * @response `200` `void`
		 */
		deleteAccountFavorite: {
			id: '/pass/band/favorite',
			request: (data: AccountFavoriteBandProfilesParamsDto, params: RequestParams = {}) =>
				this.request<void, any>({
					path: `/pass/band/favorite`,
					method: 'DELETE',
					body: data,
					secure: true,
					type: ContentType.Json,
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetAccountFavoriteInEvent
		 * @request GET:/pass/band/favorite/{eventId}
		 * @secure
		 * @response `200` `(AccountFavoriteBandProfilesInEventResultDto)[]`
		 */
		getAccountFavoriteInEvent: {
			id: '/pass/band/favorite/${eventId}',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<AccountFavoriteBandProfilesInEventResultDto[], any>({
					path: `/pass/band/favorite/${input.eventId}`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetById
		 * @request GET:/pass/band/band/{bandId}
		 * @response `200` `BandByIdResultDto`
		 */
		getById: {
			id: '/pass/band/band/${bandId}',
			request: (input: { bandId: string }, params: RequestParams = {}) =>
				this.request<BandByIdResultDto, any>({
					path: `/pass/band/band/${input.bandId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetGalleries
		 * @request GET:/pass/band/band/{bandId}/gallery
		 * @response `200` `(BandGalleriesResultDto)[]`
		 */
		getGalleries: {
			id: '/pass/band/band/${bandId}/gallery',
			request: (input: { bandId: string }, params: RequestParams = {}) =>
				this.request<BandGalleriesResultDto[], any>({
					path: `/pass/band/band/${input.bandId}/gallery`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetGalleryById
		 * @request GET:/pass/band/gallery/{galleryId}
		 * @response `200` `BandGalleryByIdResultDto`
		 */
		getGalleryById: {
			id: '/pass/band/gallery/${galleryId}',
			request: (input: { galleryId: string }, params: RequestParams = {}) =>
				this.request<BandGalleryByIdResultDto, any>({
					path: `/pass/band/gallery/${input.galleryId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetGalleryImages
		 * @request GET:/pass/band/gallery/{galleryId}/image
		 * @response `200` `(BandGalleryImagesResultDto)[]`
		 */
		getGalleryImages: {
			id: '/pass/band/gallery/${galleryId}/image',
			request: (input: { galleryId: string }, params: RequestParams = {}) =>
				this.request<BandGalleryImagesResultDto[], any>({
					path: `/pass/band/gallery/${input.galleryId}/image`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetBandPerformers
		 * @request GET:/pass/band/band/{bandId}/performer
		 * @response `200` `(BandPerformersResultDto)[]`
		 */
		getBandPerformers: {
			id: '/pass/band/band/${bandId}/performer',
			request: (input: { bandId: string }, params: RequestParams = {}) =>
				this.request<BandPerformersResultDto[], any>({
					path: `/pass/band/band/${input.bandId}/performer`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetProfileById
		 * @request GET:/pass/band/band/{bandId}/profile
		 * @response `200` `BandProfileByIdResultDto`
		 */
		getProfileById: {
			id: '/pass/band/band/${bandId}/profile',
			request: (input: { bandId: string }, params: RequestParams = {}) =>
				this.request<BandProfileByIdResultDto, any>({
					path: `/pass/band/band/${input.bandId}/profile`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetProfileBySlug
		 * @request GET:/pass/band/profile/{slug}
		 * @response `200` `BandProfileBySlugResultDto`
		 */
		getProfileBySlug: {
			id: '/pass/band/profile/${slug}',
			request: (input: { slug: string }, params: RequestParams = {}) =>
				this.request<BandProfileBySlugResultDto, any>({
					path: `/pass/band/profile/${input.slug}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetProfileList
		 * @request GET:/pass/band/band/{bandId}/profile-list
		 * @response `200` `BandProfileForListResultDto`
		 */
		getProfileList: {
			id: '/pass/band/band/${bandId}/profile-list',
			request: (input: { bandId: string }, params: RequestParams = {}) =>
				this.request<BandProfileForListResultDto, any>({
					path: `/pass/band/band/${input.bandId}/profile-list`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags band
		 * @name GetProfilesAll
		 * @request GET:/pass/band/profile
		 * @response `200` `(BandProfilesAllResultDto)[]`
		 */
		getProfilesAll: {
			id: '/pass/band/profile',
			request: (params: RequestParams = {}) =>
				this.request<BandProfilesAllResultDto[], any>({
					path: `/pass/band/profile`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	event = {
		/**
		 * No description
		 *
		 * @tags event
		 * @name EventBySlugs
		 * @request GET:/pass/event-by-slugs
		 * @response `200` `EventBySlugsResultDto`
		 */
		eventBySlugs: {
			id: '/pass/event-by-slugs',
			request: (
				query: {
					/** @maxLength 100 */
					organizerSlug: string;
					/** @maxLength 100 */
					eventSlug: string;
				},
				params: RequestParams = {},
			) =>
				this.request<EventBySlugsResultDto, any>({
					path: `/pass/event-by-slugs`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventById
		 * @request GET:/pass/event-by-id
		 * @response `200` `EventByIdResultDto`
		 */
		eventById: {
			id: '/pass/event-by-id',
			request: (
				query: {
					eventId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<EventByIdResultDto, any>({
					path: `/pass/event-by-id`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventGroupBySlug
		 * @request GET:/pass/event-group-by-slug
		 * @response `200` `EventGroupBySlugResultDto`
		 */
		eventGroupBySlug: {
			id: '/pass/event-group-by-slug',
			request: (
				query: {
					/** @maxLength 100 */
					slug: string;
				},
				params: RequestParams = {},
			) =>
				this.request<EventGroupBySlugResultDto, any>({
					path: `/pass/event-group-by-slug`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventGroupEvents
		 * @request GET:/pass/event-group-events
		 * @response `200` `(EventGroupEventsResultDto)[]`
		 */
		eventGroupEvents: {
			id: '/pass/event-group-events',
			request: (
				query: {
					eventGroupId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<EventGroupEventsResultDto[], any>({
					path: `/pass/event-group-events`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventGroupsAll
		 * @request GET:/pass/event-groups-all
		 * @response `200` `(EventGroupsByAllResultDto)[]`
		 */
		eventGroupsAll: {
			id: '/pass/event-groups-all',
			request: (params: RequestParams = {}) =>
				this.request<EventGroupsByAllResultDto[], any>({
					path: `/pass/event-groups-all`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventsAll
		 * @request GET:/pass/events-all
		 * @response `200` `(EventsAllResultDto)[]`
		 */
		eventsAll: {
			id: '/pass/events-all',
			request: (params: RequestParams = {}) =>
				this.request<EventsAllResultDto[], any>({
					path: `/pass/events-all`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventsByOrganizer
		 * @request GET:/pass/events-by-organizer
		 * @response `200` `(EventsByOrganizerResultDto)[]`
		 */
		eventsByOrganizer: {
			id: '/pass/events-by-organizer',
			request: (
				query: {
					organizerId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<EventsByOrganizerResultDto[], any>({
					path: `/pass/events-by-organizer`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventBands
		 * @request GET:/pass/event/{eventId}/bands
		 * @response `200` `(EventBandsResultDto)[]`
		 */
		eventBands: {
			id: '/pass/event/${eventId}/bands',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventBandsResultDto[], any>({
					path: `/pass/event/${input.eventId}/bands`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventEntries
		 * @request GET:/pass/event/{eventId}/entries
		 * @response `200` `(EventEntriesResultDto)[]`
		 */
		eventEntries: {
			id: '/pass/event/${eventId}/entries',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventEntriesResultDto[], any>({
					path: `/pass/event/${input.eventId}/entries`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventEntriesWithProducts
		 * @request GET:/pass/event/{eventId}/entries-with-products
		 * @response `200` `(EventEntriesWithProductsResultDto)[]`
		 */
		eventEntriesWithProducts: {
			id: '/pass/event/${eventId}/entries-with-products',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventEntriesWithProductsResultDto[], any>({
					path: `/pass/event/${input.eventId}/entries-with-products`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventMainBands
		 * @request GET:/pass/event/{eventId}/main-bands
		 * @response `200` `(EventMainBandsResultDto)[]`
		 */
		eventMainBands: {
			id: '/pass/event/${eventId}/main-bands',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventMainBandsResultDto[], any>({
					path: `/pass/event/${input.eventId}/main-bands`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventMainPerformers
		 * @request GET:/pass/event/{eventId}/main-performers
		 * @response `200` `(EventMainPerformersResultDto)[]`
		 */
		eventMainPerformers: {
			id: '/pass/event/${eventId}/main-performers',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventMainPerformersResultDto[], any>({
					path: `/pass/event/${input.eventId}/main-performers`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventPerformers
		 * @request GET:/pass/event/{eventId}/performers
		 * @response `200` `(EventPerformersResultDto)[]`
		 */
		eventPerformers: {
			id: '/pass/event/${eventId}/performers',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventPerformersResultDto[], any>({
					path: `/pass/event/${input.eventId}/performers`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventStages
		 * @request GET:/pass/event/{eventId}/stages
		 * @response `200` `(EventStagesResultDto)[]`
		 */
		eventStages: {
			id: '/pass/event/${eventId}/stages',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventStagesResultDto[], any>({
					path: `/pass/event/${input.eventId}/stages`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventPaymentMethods
		 * @request GET:/pass/event/{eventId}/payment-method
		 * @response `200` `(EventPaymentMethodsResultDto)[]`
		 */
		eventPaymentMethods: {
			id: '/pass/event/${eventId}/payment-method',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<EventPaymentMethodsResultDto[], any>({
					path: `/pass/event/${input.eventId}/payment-method`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventSectors
		 * @request GET:/pass/event/{eventId}/sector
		 * @response `200` `(FindEventSectorsResultDto)[]`
		 */
		eventSectors: {
			id: '/pass/event/${eventId}/sector',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<FindEventSectorsResultDto[], any>({
					path: `/pass/event/${input.eventId}/sector`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags event
		 * @name EventVenue
		 * @request GET:/pass/event/{eventId}/venue
		 * @response `200` `FindEventVenueResultDto`
		 */
		eventVenue: {
			id: '/pass/event/${eventId}/venue',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<FindEventVenueResultDto, any>({
					path: `/pass/event/${input.eventId}/venue`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	gallery = {
		/**
		 * No description
		 *
		 * @tags gallery
		 * @name GalleryImages
		 * @request GET:/pass/gallery-images
		 * @response `200` `(GalleryImagesResultDto)[]`
		 */
		galleryImages: {
			id: '/pass/gallery-images',
			request: (
				query: {
					galleryId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<GalleryImagesResultDto[], any>({
					path: `/pass/gallery-images`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags gallery
		 * @name GalleryById
		 * @request GET:/pass/gallery-by-id
		 * @response `200` `GalleryByIdResultDto`
		 */
		galleryById: {
			id: '/pass/gallery-by-id',
			request: (
				query: {
					galleryId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<GalleryByIdResultDto, any>({
					path: `/pass/gallery-by-id`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},
	};
	order = {
		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderById
		 * @request GET:/pass/order-by-id
		 * @response `200` `OrderByIdResultDto`
		 */
		orderById: {
			id: '/pass/order-by-id',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderByIdResultDto, any>({
					path: `/pass/order-by-id`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderCancel
		 * @request POST:/pass/order-cancel
		 * @response `201` `OrderCancelResultDto`
		 */
		orderCancel: {
			id: '/pass/order-cancel',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderCancelResultDto, any>({
					path: `/pass/order-cancel`,
					method: 'POST',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderCheck
		 * @request GET:/pass/order-check
		 * @response `200` `OrderCheckResultDto`
		 */
		orderCheck: {
			id: '/pass/order-check',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderCheckResultDto, any>({
					path: `/pass/order-check`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderCreate
		 * @summary Use order-create-v2 instead
		 * @request POST:/pass/order-create
		 * @deprecated
		 * @response `201` `OrderCreateResultDto`
		 */
		orderCreate: {
			id: '/pass/order-create',
			request: (data: OrderCreateParamsDto, params: RequestParams = {}) =>
				this.request<OrderCreateResultDto, any>({
					path: `/pass/order-create`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderCreateV2
		 * @request POST:/pass/order-create-v2
		 * @response `201` `OrderCreateResultDto`
		 */
		orderCreateV2: {
			id: '/pass/order-create-v2',
			request: (data: OrderCreateV2BodyDto, params: RequestParams = {}) =>
				this.request<OrderCreateResultDto, any>({
					path: `/pass/order-create-v2`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderCreateExtra
		 * @request POST:/pass/order-create-extra
		 * @secure
		 * @response `201` `OrderCreateResultDto`
		 */
		orderCreateExtra: {
			id: '/pass/order-create-extra',
			request: (data: OrderCreateExtraParamsDto, params: RequestParams = {}) =>
				this.request<OrderCreateResultDto, any>({
					path: `/pass/order-create-extra`,
					method: 'POST',
					body: data,
					secure: true,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderCreateCredit
		 * @request POST:/pass/order-create-credit
		 * @secure
		 * @response `201` `OrderCreateResultDto`
		 */
		orderCreateCredit: {
			id: '/pass/order-create-credit',
			request: (data: OrderCreateCreditParamsDto, params: RequestParams = {}) =>
				this.request<OrderCreateResultDto, any>({
					path: `/pass/order-create-credit`,
					method: 'POST',
					body: data,
					secure: true,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderCreateCreditFromCode
		 * @request POST:/pass/order-create-credit-from-code
		 * @response `201` `OrderCreateResultDto`
		 */
		orderCreateCreditFromCode: {
			id: '/pass/order-create-credit-from-code',
			request: (data: OrderCreateCreditFromCodeBodyDto, params: RequestParams = {}) =>
				this.request<OrderCreateResultDto, any>({
					path: `/pass/order-create-credit-from-code`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderBookingStatus
		 * @summary Use /pass/v2/event/order/{orderId}/status instead
		 * @request GET:/pass/order-booking-status
		 * @deprecated
		 * @response `200` `OrderStatusResultDto`
		 */
		orderBookingStatus: {
			id: '/pass/order-booking-status',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderStatusResultDto, any>({
					path: `/pass/order-booking-status`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderReceipts
		 * @request GET:/pass/order-receipts
		 * @response `200` `(OrderReceiptsResultDto)[]`
		 */
		orderReceipts: {
			id: '/pass/order-receipts',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderReceiptsResultDto[], any>({
					path: `/pass/order-receipts`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderReceiptsV2
		 * @request GET:/pass/order-receipts-v2
		 * @response `200` `OrderReceiptsV2ResultDto`
		 */
		orderReceiptsV2: {
			id: '/pass/order-receipts-v2',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderReceiptsV2ResultDto, any>({
					path: `/pass/order-receipts-v2`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name ExtraOrderReceipts
		 * @request GET:/pass/extra-order-receipts
		 * @response `200` `ExtraOrderReceiptsResultDto`
		 */
		extraOrderReceipts: {
			id: '/pass/extra-order-receipts',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<ExtraOrderReceiptsResultDto, any>({
					path: `/pass/extra-order-receipts`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderTickets
		 * @request GET:/pass/order-tickets
		 * @response `200` `(OrderTicketsResultDto)[]`
		 */
		orderTickets: {
			id: '/pass/order-tickets',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderTicketsResultDto[], any>({
					path: `/pass/order-tickets`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderVouchers
		 * @request GET:/pass/order-vouchers
		 * @response `200` `(OrderVouchersResultDto)[]`
		 */
		orderVouchers: {
			id: '/pass/order-vouchers',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderVouchersResultDto[], any>({
					path: `/pass/order-vouchers`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name OrderContent
		 * @request GET:/pass/order-content
		 * @response `200` `OrderContentResultDto`
		 */
		orderContent: {
			id: '/pass/order-content',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrderContentResultDto, any>({
					path: `/pass/order-content`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name TransferDetails
		 * @request GET:/pass/bank-transaction
		 * @response `200` `FindBankTransactionResultDto`
		 */
		transferDetails: {
			id: '/pass/bank-transaction',
			request: (
				query: {
					orderId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<FindBankTransactionResultDto, any>({
					path: `/pass/bank-transaction`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags order
		 * @name DownloadTicket
		 * @request GET:/pass/order-download-ticket
		 * @response `200` `void`
		 */
		downloadTicket: {
			id: '/pass/order-download-ticket',
			request: (
				query: {
					ticketId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<void, any>({
					path: `/pass/order-download-ticket`,
					method: 'GET',
					query: query,
					...params,
				}),
		},
	};
	organizer = {
		/**
		 * No description
		 *
		 * @tags organizer
		 * @name OrganizerBySlug
		 * @request GET:/pass/organizer-by-slug
		 * @response `200` `OrganizerBySlugResultDto`
		 */
		organizerBySlug: {
			id: '/pass/organizer-by-slug',
			request: (
				query: {
					/** @maxLength 100 */
					slug: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrganizerBySlugResultDto, any>({
					path: `/pass/organizer-by-slug`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags organizer
		 * @name OrganizerEventGroups
		 * @request GET:/pass/organizer-event-groups
		 * @response `200` `(OrganizerEventGroupsResultDto)[]`
		 */
		organizerEventGroups: {
			id: '/pass/organizer-event-groups',
			request: (
				query: {
					organizerId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<OrganizerEventGroupsResultDto[], any>({
					path: `/pass/organizer-event-groups`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags organizer
		 * @name OrganizersAll
		 * @request GET:/pass/organizers-all
		 * @response `200` `(OrganizersAllResultDto)[]`
		 */
		organizersAll: {
			id: '/pass/organizers-all',
			request: (params: RequestParams = {}) =>
				this.request<OrganizersAllResultDto[], any>({
					path: `/pass/organizers-all`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	performer = {
		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetAccountFavorite
		 * @request GET:/pass/performer/favorite
		 * @secure
		 * @response `200` `(AccountFavoritePerformerProfilesResultDto)[]`
		 */
		getAccountFavorite: {
			id: '/pass/performer/favorite',
			request: (params: RequestParams = {}) =>
				this.request<AccountFavoritePerformerProfilesResultDto[], any>({
					path: `/pass/performer/favorite`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name CreateAccountFavorite
		 * @request POST:/pass/performer/favorite
		 * @secure
		 * @response `201` `void`
		 */
		createAccountFavorite: {
			id: '/pass/performer/favorite',
			request: (data: AccountFavoritePerformerProfilesParamsDto, params: RequestParams = {}) =>
				this.request<void, any>({
					path: `/pass/performer/favorite`,
					method: 'POST',
					body: data,
					secure: true,
					type: ContentType.Json,
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name DeleteAccountFavorite
		 * @request DELETE:/pass/performer/favorite
		 * @secure
		 * @response `200` `void`
		 */
		deleteAccountFavorite: {
			id: '/pass/performer/favorite',
			request: (data: AccountFavoritePerformerProfilesResultDto, params: RequestParams = {}) =>
				this.request<void, any>({
					path: `/pass/performer/favorite`,
					method: 'DELETE',
					body: data,
					secure: true,
					type: ContentType.Json,
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetAccountFavoriteInEvent
		 * @request GET:/pass/performer/favorite/{eventId}
		 * @secure
		 * @response `200` `(AccountFavoritePerformerProfilesInEventResultDto)[]`
		 */
		getAccountFavoriteInEvent: {
			id: '/pass/performer/favorite/${eventId}',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<AccountFavoritePerformerProfilesInEventResultDto[], any>({
					path: `/pass/performer/favorite/${input.eventId}`,
					method: 'GET',
					secure: true,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetById
		 * @request GET:/pass/performer/performer/{performerId}
		 * @response `200` `PerformerByIdResultDto`
		 */
		getById: {
			id: '/pass/performer/performer/${performerId}',
			request: (input: { performerId: string }, params: RequestParams = {}) =>
				this.request<PerformerByIdResultDto, any>({
					path: `/pass/performer/performer/${input.performerId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetBands
		 * @request GET:/pass/performer/performer/{performerId}/bands
		 * @response `200` `(PerformerBandsResultDto)[]`
		 */
		getBands: {
			id: '/pass/performer/performer/${performerId}/bands',
			request: (input: { performerId: string }, params: RequestParams = {}) =>
				this.request<PerformerBandsResultDto[], any>({
					path: `/pass/performer/performer/${input.performerId}/bands`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetGalleries
		 * @request GET:/pass/performer/performer/{performerId}/gallery
		 * @response `200` `(PerformerGalleriesResultDto)[]`
		 */
		getGalleries: {
			id: '/pass/performer/performer/${performerId}/gallery',
			request: (input: { performerId: string }, params: RequestParams = {}) =>
				this.request<PerformerGalleriesResultDto[], any>({
					path: `/pass/performer/performer/${input.performerId}/gallery`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetGalleryById
		 * @request GET:/pass/performer/gallery/{galleryId}
		 * @response `200` `PerformerGalleryByIdResultDto`
		 */
		getGalleryById: {
			id: '/pass/performer/gallery/${galleryId}',
			request: (input: { galleryId: string }, params: RequestParams = {}) =>
				this.request<PerformerGalleryByIdResultDto, any>({
					path: `/pass/performer/gallery/${input.galleryId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetGalleryImages
		 * @request GET:/pass/performer/gallery/{galleryId}/image
		 * @response `200` `(PerformerGalleryImagesResultDto)[]`
		 */
		getGalleryImages: {
			id: '/pass/performer/gallery/${galleryId}/image',
			request: (input: { galleryId: string }, params: RequestParams = {}) =>
				this.request<PerformerGalleryImagesResultDto[], any>({
					path: `/pass/performer/gallery/${input.galleryId}/image`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetProfileById
		 * @request GET:/pass/performer/performer/{performerId}/profile
		 * @response `200` `PerformerProfileByIdResultDto`
		 */
		getProfileById: {
			id: '/pass/performer/performer/${performerId}/profile',
			request: (input: { performerId: string }, params: RequestParams = {}) =>
				this.request<PerformerProfileByIdResultDto, any>({
					path: `/pass/performer/performer/${input.performerId}/profile`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetProfileBySlug
		 * @request GET:/pass/performer/profile/{slug}
		 * @response `200` `PerformerProfileBySlugResultDto`
		 */
		getProfileBySlug: {
			id: '/pass/performer/profile/${slug}',
			request: (input: { slug: string }, params: RequestParams = {}) =>
				this.request<PerformerProfileBySlugResultDto, any>({
					path: `/pass/performer/profile/${input.slug}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetProfileList
		 * @request GET:/pass/performer/performer/{performerId}/profile-list
		 * @response `200` `PerformerProfileForListResultDto`
		 */
		getProfileList: {
			id: '/pass/performer/performer/${performerId}/profile-list',
			request: (input: { performerId: string }, params: RequestParams = {}) =>
				this.request<PerformerProfileForListResultDto, any>({
					path: `/pass/performer/performer/${input.performerId}/profile-list`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags performer
		 * @name GetProfilesAll
		 * @request GET:/pass/performer/profile
		 * @response `200` `(PerformerProfilesAllResultDto)[]`
		 */
		getProfilesAll: {
			id: '/pass/performer/profile',
			request: (params: RequestParams = {}) =>
				this.request<PerformerProfilesAllResultDto[], any>({
					path: `/pass/performer/profile`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	product = {
		/**
		 * No description
		 *
		 * @tags product
		 * @name GetProductGroup
		 * @request GET:/pass/product-group/{productGroupId}
		 * @response `200` `ProductGroupResultDto`
		 */
		getProductGroup: {
			id: '/pass/product-group/${productGroupId}',
			request: (input: { productGroupId: string }, params: RequestParams = {}) =>
				this.request<ProductGroupResultDto, any>({
					path: `/pass/product-group/${input.productGroupId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags product
		 * @name GetProductGroupVariants
		 * @request GET:/pass/product-group/{productGroupId}/variants
		 * @response `200` `(ProductGroupVariantsResultDto)[]`
		 */
		getProductGroupVariants: {
			id: '/pass/product-group/${productGroupId}/variants',
			request: (input: { productGroupId: string }, params: RequestParams = {}) =>
				this.request<ProductGroupVariantsResultDto[], any>({
					path: `/pass/product-group/${input.productGroupId}/variants`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags product
		 * @name GetVariantValues
		 * @request GET:/pass/variant/{variantId}/values
		 * @response `200` `(VariantValuesResultDto)[]`
		 */
		getVariantValues: {
			id: '/pass/variant/${variantId}/values',
			request: (input: { variantId: string }, params: RequestParams = {}) =>
				this.request<VariantValuesResultDto[], any>({
					path: `/pass/variant/${input.variantId}/values`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags product
		 * @name GetTicketProductVariantValues
		 * @request GET:/pass/ticket-product/{ticketProductId}/values
		 * @response `200` `(TicketProductVariantValuesResultDto)[]`
		 */
		getTicketProductVariantValues: {
			id: '/pass/ticket-product/${ticketProductId}/values',
			request: (input: { ticketProductId: string }, params: RequestParams = {}) =>
				this.request<TicketProductVariantValuesResultDto[], any>({
					path: `/pass/ticket-product/${input.ticketProductId}/values`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	program = {
		/**
		 * No description
		 *
		 * @tags program
		 * @name StageEntries
		 * @request GET:/pass/stage/{stageId}/entries
		 * @response `200` `(StageEntriesResultDto)[]`
		 */
		stageEntries: {
			id: '/pass/stage/${stageId}/entries',
			request: (input: { stageId: string }, params: RequestParams = {}) =>
				this.request<StageEntriesResultDto[], any>({
					path: `/pass/stage/${input.stageId}/entries`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags program
		 * @name EntryBands
		 * @request GET:/pass/entry/{entryId}/bands
		 * @response `200` `(EntryBandsResultDto)[]`
		 */
		entryBands: {
			id: '/pass/entry/${entryId}/bands',
			request: (input: { entryId: string }, params: RequestParams = {}) =>
				this.request<EntryBandsResultDto[], any>({
					path: `/pass/entry/${input.entryId}/bands`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags program
		 * @name EntryPerformers
		 * @request GET:/pass/entry/{entryId}/performers
		 * @response `200` `(EntryPerformersResultDto)[]`
		 */
		entryPerformers: {
			id: '/pass/entry/${entryId}/performers',
			request: (input: { entryId: string }, params: RequestParams = {}) =>
				this.request<EntryPerformersResultDto[], any>({
					path: `/pass/entry/${input.entryId}/performers`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags program
		 * @name EntryProducts
		 * @request GET:/pass/entry/{entryId}/products
		 * @response `200` `(EntryProductsResultDto)[]`
		 */
		entryProducts: {
			id: '/pass/entry/${entryId}/products',
			request: (input: { entryId: string }, params: RequestParams = {}) =>
				this.request<EntryProductsResultDto[], any>({
					path: `/pass/entry/${input.entryId}/products`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	receipt = {
		/**
		 * No description
		 *
		 * @tags receipt
		 * @name ReceiptProducts
		 * @request GET:/pass/receipt-products
		 * @response `200` `(ReceiptProductsResultDto)[]`
		 */
		receiptProducts: {
			id: '/pass/receipt-products',
			request: (
				query: {
					receiptId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<ReceiptProductsResultDto[], any>({
					path: `/pass/receipt-products`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags receipt
		 * @name ReceiptVatTable
		 * @request GET:/pass/receipt-vat-table
		 * @response `200` `(ReceiptVatTableResultDto)[]`
		 */
		receiptVatTable: {
			id: '/pass/receipt-vat-table',
			request: (
				query: {
					receiptId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<ReceiptVatTableResultDto[], any>({
					path: `/pass/receipt-vat-table`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},
	};
	reservation = {
		/**
		 * No description
		 *
		 * @tags reservation
		 * @name Create
		 * @request POST:/pass/reservation
		 * @response `201` `CreateReservationReservationResultDto`
		 */
		create: {
			id: '/pass/reservation',
			request: (data: CreateReservationReservationBodyDto, params: RequestParams = {}) =>
				this.request<CreateReservationReservationResultDto, any>({
					path: `/pass/reservation`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags reservation
		 * @name Cancel
		 * @request DELETE:/pass/reservation
		 * @response `200` `ErrorText`
		 */
		cancel: {
			id: '/pass/reservation',
			request: (
				query: {
					reservationId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<ErrorText, any>({
					path: `/pass/reservation`,
					method: 'DELETE',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags reservation
		 * @name CreateReservationCrowd
		 * @request POST:/pass/reservation/reservation-crowd
		 * @response `201` `CreateReservationReservationCrowdResultDto`
		 */
		createReservationCrowd: {
			id: '/pass/reservation/reservation-crowd',
			request: (data: CreateReservationReservationCrowdBodyDto, params: RequestParams = {}) =>
				this.request<CreateReservationReservationCrowdResultDto, any>({
					path: `/pass/reservation/reservation-crowd`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags reservation
		 * @name CreateReservationSeat
		 * @request POST:/pass/reservation/reservation-seat
		 * @response `201` `CreateReservationReservationSeatResultDto`
		 */
		createReservationSeat: {
			id: '/pass/reservation/reservation-seat',
			request: (data: CreateReservationReservationSeatBodyDto, params: RequestParams = {}) =>
				this.request<CreateReservationReservationSeatResultDto, any>({
					path: `/pass/reservation/reservation-seat`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags reservation
		 * @name FindOneSector
		 * @request GET:/pass/reservation/sector/{sectorId}
		 * @response `200` `FindOneReservationSectorResultDto`
		 */
		findOneSector: {
			id: '/pass/reservation/sector/${sectorId}',
			request: (input: { sectorId: string }, params: RequestParams = {}) =>
				this.request<FindOneReservationSectorResultDto, any>({
					path: `/pass/reservation/sector/${input.sectorId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags reservation
		 * @name FindAllSectorSeats
		 * @request GET:/pass/reservation/sector/{sectorId}/seat
		 * @response `200` `(FindAllSectorSeatsResultDto)[]`
		 */
		findAllSectorSeats: {
			id: '/pass/reservation/sector/${sectorId}/seat',
			request: (input: { sectorId: string }, params: RequestParams = {}) =>
				this.request<FindAllSectorSeatsResultDto[], any>({
					path: `/pass/reservation/sector/${input.sectorId}/seat`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	ticket = {
		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketTypesByEvent
		 * @request GET:/pass/ticket-types-by-event
		 * @deprecated
		 * @response `200` `(TicketTypesByEventResultDto)[]`
		 */
		ticketTypesByEvent: {
			id: '/pass/ticket-types-by-event',
			request: (
				query: {
					eventId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketTypesByEventResultDto[], any>({
					path: `/pass/ticket-types-by-event`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketTypeById
		 * @request GET:/pass/ticket-types-by-id
		 * @deprecated
		 * @response `200` `TicketTypeByIdResultDto`
		 */
		ticketTypeById: {
			id: '/pass/ticket-types-by-id',
			request: (
				query: {
					ticketTypeId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketTypeByIdResultDto, any>({
					path: `/pass/ticket-types-by-id`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketTypesExtraProducts
		 * @request GET:/pass/ticket-types-extra-products
		 * @response `200` `(TicketTypesExtraProductsResultDto)[]`
		 */
		ticketTypesExtraProducts: {
			id: '/pass/ticket-types-extra-products',
			request: (
				query: {
					ticketTypeId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketTypesExtraProductsResultDto[], any>({
					path: `/pass/ticket-types-extra-products`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketTypeContentItemTypes
		 * @request GET:/pass/ticket-type-content-item-types
		 * @response `200` `(TicketContentItemTypesResultDto)[]`
		 */
		ticketTypeContentItemTypes: {
			id: '/pass/ticket-type-content-item-types',
			request: (
				query: {
					ticketTypeId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketContentItemTypesResultDto[], any>({
					path: `/pass/ticket-type-content-item-types`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketProductItemTypes
		 * @request GET:/pass/ticket-product-item-types
		 * @response `200` `(ProductItemTypesResultDto)[]`
		 */
		ticketProductItemTypes: {
			id: '/pass/ticket-product-item-types',
			request: (
				query: {
					ticketTypeId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<ProductItemTypesResultDto[], any>({
					path: `/pass/ticket-product-item-types`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name ChipCreditLimit
		 * @request GET:/pass/chip-credit-limit
		 * @response `200` `ChipCreditLimitResultDto`
		 */
		chipCreditLimit: {
			id: '/pass/chip-credit-limit',
			request: (
				query: {
					/** @minLength 11 */
					chipId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<ChipCreditLimitResultDto, any>({
					path: `/pass/chip-credit-limit`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketExtraProducts
		 * @request GET:/pass/ticket-extra-products
		 * @response `200` `(TicketExtraProductsResultDto)[]`
		 */
		ticketExtraProducts: {
			id: '/pass/ticket-extra-products',
			request: (
				query: {
					ticketId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketExtraProductsResultDto[], any>({
					path: `/pass/ticket-extra-products`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketCoupon
		 * @request GET:/pass/ticket-coupon
		 * @response `200` `TicketCouponResultDto`
		 */
		ticketCoupon: {
			id: '/pass/ticket-coupon',
			request: (
				query: {
					/** @maxLength 50 */
					coupon: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketCouponResultDto, any>({
					path: `/pass/ticket-coupon`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketSupercoupon
		 * @request GET:/pass/ticket-supercoupon
		 * @response `200` `TicketSupercouponResultDto`
		 */
		ticketSupercoupon: {
			id: '/pass/ticket-supercoupon',
			request: (
				query: {
					/** @maxLength 50 */
					supercoupon: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketSupercouponResultDto, any>({
					path: `/pass/ticket-supercoupon`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketSupercouponTicketTypes
		 * @request GET:/pass/ticket-supercoupon-ticket-types
		 * @response `200` `(TicketSupercouponTicketTypesResultDto)[]`
		 */
		ticketSupercouponTicketTypes: {
			id: '/pass/ticket-supercoupon-ticket-types',
			request: (
				query: {
					ticketSupercouponId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketSupercouponTicketTypesResultDto[], any>({
					path: `/pass/ticket-supercoupon-ticket-types`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketSupercouponRedeem
		 * @request POST:/pass/ticket-supercoupon-redeem
		 * @response `201` `TicketSupercouponRedeemResultDto`
		 */
		ticketSupercouponRedeem: {
			id: '/pass/ticket-supercoupon-redeem',
			request: (data: TicketSupercouponRedeemBodyDto, params: RequestParams = {}) =>
				this.request<TicketSupercouponRedeemResultDto, any>({
					path: `/pass/ticket-supercoupon-redeem`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketById
		 * @request GET:/pass/ticket-by-id
		 * @response `200` `TicketByIdResultDto`
		 */
		ticketById: {
			id: '/pass/ticket-by-id',
			request: (
				query: {
					ticketId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketByIdResultDto, any>({
					path: `/pass/ticket-by-id`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketItems
		 * @request GET:/pass/ticket-items
		 * @response `200` `(TicketItemsResultDto)[]`
		 */
		ticketItems: {
			id: '/pass/ticket-items',
			request: (
				query: {
					ticketId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketItemsResultDto[], any>({
					path: `/pass/ticket-items`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketProducts
		 * @request GET:/pass/ticket-products
		 * @response `200` `(TicketProductsResultDto)[]`
		 */
		ticketProducts: {
			id: '/pass/ticket-products',
			request: (
				query: {
					ticketId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketProductsResultDto[], any>({
					path: `/pass/ticket-products`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketChips
		 * @request GET:/pass/ticket-chips
		 * @response `200` `(TicketChipsResultDto)[]`
		 */
		ticketChips: {
			id: '/pass/ticket-chips',
			request: (
				query: {
					ticketId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketChipsResultDto[], any>({
					path: `/pass/ticket-chips`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags ticket
		 * @name TicketByCode
		 * @request GET:/pass/ticket-by-code
		 * @response `200` `TicketByCodeResultDto`
		 */
		ticketByCode: {
			id: '/pass/ticket-by-code',
			request: (
				query: {
					/** @maxLength 100 */
					qrCode: string;
				},
				params: RequestParams = {},
			) =>
				this.request<TicketByCodeResultDto, any>({
					path: `/pass/ticket-by-code`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},
	};
	v2Event = {
		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetEventById
		 * @request GET:/pass/v2/event/id/{eventId}
		 * @response `200` `FindOneEventResultDto`
		 */
		getEventById: {
			id: '/pass/v2/event/id/${eventId}',
			request: (
				input: { eventId: string },
				query?: {
					language?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
				},
				params: RequestParams = {},
			) =>
				this.request<FindOneEventResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetTicketTypesFromEventFull
		 * @request GET:/pass/v2/event/id/{eventId}/ticket-type
		 * @response `200` `(GetTicketTypesFullResultDto)[]`
		 */
		getTicketTypesFromEventFull: {
			id: '/pass/v2/event/id/${eventId}/ticket-type',
			request: (
				input: { eventId: string },
				query?: {
					language?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
					filter?: string;
				},
				params: RequestParams = {},
			) =>
				this.request<GetTicketTypesFullResultDto[], any>({
					path: `/pass/v2/event/id/${input.eventId}/ticket-type`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetExtraProductsFromEvent
		 * @request GET:/pass/v2/event/id/{eventId}/extra-products
		 * @response `200` `GetExtraProductsFromEventResultDto`
		 */
		getExtraProductsFromEvent: {
			id: '/pass/v2/event/id/${eventId}/extra-products',
			request: (
				input: { eventId: string },
				query?: {
					language?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
				},
				params: RequestParams = {},
			) =>
				this.request<GetExtraProductsFromEventResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}/extra-products`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetEventEventGroups
		 * @request GET:/pass/v2/event/id/{eventId}/event-group
		 * @response `200` `GetEventEventGroupsResultDto`
		 */
		getEventEventGroups: {
			id: '/pass/v2/event/id/${eventId}/event-group',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<GetEventEventGroupsResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}/event-group`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindOneCoupon
		 * @request GET:/pass/v2/event/id/{eventId}/ticket-type/coupon
		 * @response `200` `FindOneCouponResultDto`
		 */
		findOneCoupon: {
			id: '/pass/v2/event/id/${eventId}/ticket-type/coupon',
			request: (
				input: { eventId: string },
				query: {
					language?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
					code: string;
				},
				params: RequestParams = {},
			) =>
				this.request<FindOneCouponResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}/ticket-type/coupon`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetActiveOrgPartnersFromEvent
		 * @request GET:/pass/v2/event/id/{eventId}/ticket-type/org-partner
		 * @response `200` `(GetActiveOrgPartnersFromEventResultDto)[]`
		 */
		getActiveOrgPartnersFromEvent: {
			id: '/pass/v2/event/id/${eventId}/ticket-type/org-partner',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<GetActiveOrgPartnersFromEventResultDto[], any>({
					path: `/pass/v2/event/id/${input.eventId}/ticket-type/org-partner`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetTicketPriceRangeFromEvent
		 * @request GET:/pass/v2/event/id/{eventId}/ticket/price-range
		 * @response `200` `GetTicketPriceRangeFromEventResultDto`
		 */
		getTicketPriceRangeFromEvent: {
			id: '/pass/v2/event/id/${eventId}/ticket/price-range',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<GetTicketPriceRangeFromEventResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}/ticket/price-range`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetTicketTypesFromEventQuick
		 * @request GET:/pass/v2/event/id/{eventId}/ticket-type/quick-stats
		 * @response `200` `(FindAllTicketTypesFromEventQuickStatsResultDto)[]`
		 */
		getTicketTypesFromEventQuick: {
			id: '/pass/v2/event/id/${eventId}/ticket-type/quick-stats',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<FindAllTicketTypesFromEventQuickStatsResultDto[], any>({
					path: `/pass/v2/event/id/${input.eventId}/ticket-type/quick-stats`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindAllReservationCategoriesFromEvent
		 * @request GET:/pass/v2/event/id/{eventId}/reservation/category
		 * @response `200` `(FindAllReservationCategoriesFromEventResultDto)[]`
		 */
		findAllReservationCategoriesFromEvent: {
			id: '/pass/v2/event/id/${eventId}/reservation/category',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<FindAllReservationCategoriesFromEventResultDto[], any>({
					path: `/pass/v2/event/id/${input.eventId}/reservation/category`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindOneVenueWithSectors
		 * @request GET:/pass/v2/event/id/{eventId}/venue
		 * @response `200` `FindOneVenueFromEventResultDto`
		 */
		findOneVenueWithSectors: {
			id: '/pass/v2/event/id/${eventId}/venue',
			request: (input: { eventId: string }, params: RequestParams = {}) =>
				this.request<FindOneVenueFromEventResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}/venue`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindTicketByCode
		 * @request GET:/pass/v2/event/id/{eventId}/ticket/qrCode/{qrCode}
		 * @response `200` `FindOneTicketByCodeResultDto`
		 */
		findTicketByCode: {
			id: '/pass/v2/event/id/${eventId}/ticket/qrCode/${qrCode}',
			request: (input: { eventId: string; qrCode: string }, params: RequestParams = {}) =>
				this.request<FindOneTicketByCodeResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}/ticket/qrCode/${input.qrCode}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindAllVisibleEventsSlugs
		 * @request GET:/pass/v2/event/static-path
		 * @response `200` `(FindAllVisibleEventsSlugsResultDto)[]`
		 */
		findAllVisibleEventsSlugs: {
			id: '/pass/v2/event/static-path',
			request: (params: RequestParams = {}) =>
				this.request<FindAllVisibleEventsSlugsResultDto[], any>({
					path: `/pass/v2/event/static-path`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindOneOrderStatus
		 * @request GET:/pass/v2/event/order/{orderId}/status
		 * @response `200` `FindOneOrderStatusResultDto`
		 */
		findOneOrderStatus: {
			id: '/pass/v2/event/order/${orderId}/status',
			request: (input: { orderId: string }, params: RequestParams = {}) =>
				this.request<FindOneOrderStatusResultDto, any>({
					path: `/pass/v2/event/order/${input.orderId}/status`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindAllVisibleEventGroupsSlugs
		 * @request GET:/pass/v2/event/group/static-path
		 * @response `200` `(FindAllVisibleEventGroupsSlugsResultDto)[]`
		 */
		findAllVisibleEventGroupsSlugs: {
			id: '/pass/v2/event/group/static-path',
			request: (params: RequestParams = {}) =>
				this.request<FindAllVisibleEventGroupsSlugsResultDto[], any>({
					path: `/pass/v2/event/group/static-path`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetEventGroupBySlug
		 * @request GET:/pass/v2/event/group/slug/{eventGroupSlug}
		 * @response `200` `GetEventGroupBySlugResultDto`
		 */
		getEventGroupBySlug: {
			id: '/pass/v2/event/group/slug/${eventGroupSlug}',
			request: (
				input: { eventGroupSlug: string },
				query?: {
					language?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
				},
				params: RequestParams = {},
			) =>
				this.request<GetEventGroupBySlugResultDto, any>({
					path: `/pass/v2/event/group/slug/${input.eventGroupSlug}`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name FindOrgPartnerByEventGroupSlug
		 * @request GET:/pass/v2/event/group/slug/{slug}/orgPartner
		 * @response `200` `FindOrgPartnerByEventGroupSlugResultDto`
		 */
		findOrgPartnerByEventGroupSlug: {
			id: '/pass/v2/event/group/slug/${slug}/orgPartner',
			request: (
				input: { slug: string },
				query: {
					/** @maxLength 10 */
					shortCode: string;
				},
				params: RequestParams = {},
			) =>
				this.request<FindOrgPartnerByEventGroupSlugResultDto, any>({
					path: `/pass/v2/event/group/slug/${input.slug}/orgPartner`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetEventGroupVisibleEventsById
		 * @request GET:/pass/v2/event/group/{eventGroupId}/visible-events
		 * @response `200` `(GetEventGroupVisibleEventsByIdResultDto)[]`
		 */
		getEventGroupVisibleEventsById: {
			id: '/pass/v2/event/group/${eventGroupId}/visible-events',
			request: (input: { eventGroupId: string }, params: RequestParams = {}) =>
				this.request<GetEventGroupVisibleEventsByIdResultDto[], any>({
					path: `/pass/v2/event/group/${input.eventGroupId}/visible-events`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name GetEventBySlugs
		 * @request GET:/pass/v2/event/{organizerSlug}/{eventSlug}
		 * @response `200` `FindOneEventResultDto`
		 */
		getEventBySlugs: {
			id: '/pass/v2/event/${organizerSlug}/${eventSlug}',
			request: (
				input: { organizerSlug: string; eventSlug: string },
				query?: {
					language?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
				},
				params: RequestParams = {},
			) =>
				this.request<FindOneEventResultDto, any>({
					path: `/pass/v2/event/${input.organizerSlug}/${input.eventSlug}`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name EventsByOrganizer
		 * @request GET:/pass/v2/event/events-by-organizer
		 * @response `200` `(EventsByOrganizerResultDto)[]`
		 */
		eventsByOrganizer: {
			id: '/pass/v2/event/events-by-organizer',
			request: (
				query: {
					organizerId: string;
				},
				params: RequestParams = {},
			) =>
				this.request<EventsByOrganizerResultDto[], any>({
					path: `/pass/v2/event/events-by-organizer`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/event
		 * @name CheckDiscountCode
		 * @request POST:/pass/v2/event/id/{eventId}/check-discount-code/{code}
		 * @response `201` `CheckDiscountCodeResultDto`
		 */
		checkDiscountCode: {
			id: '/pass/v2/event/id/${eventId}/check-discount-code/${code}',
			request: (
				input: { eventId: string; code: string },
				query?: {
					language?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
				},
				params: RequestParams = {},
			) =>
				this.request<CheckDiscountCodeResultDto, any>({
					path: `/pass/v2/event/id/${input.eventId}/check-discount-code/${input.code}`,
					method: 'POST',
					query: query,
					format: 'json',
					...params,
				}),
		},
	};
	v2Ticket = {
		/**
		 * No description
		 *
		 * @tags v2/ticket
		 * @name FindExtraProductsFromTicketType
		 * @request GET:/pass/v2/ticket/extra-products
		 * @response `200` `(FindAllExtraProductsFromTicketTypeResultDto)[]`
		 */
		findExtraProductsFromTicketType: {
			id: '/pass/v2/ticket/extra-products',
			request: (
				query: {
					ticketTypes: string[];
				},
				params: RequestParams = {},
			) =>
				this.request<FindAllExtraProductsFromTicketTypeResultDto[], any>({
					path: `/pass/v2/ticket/extra-products`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/ticket
		 * @name FindGroupsFromTicketType
		 * @request GET:/pass/v2/ticket/groups
		 * @response `200` `(FindAllProductGroupsFromTicketTypeResultDto)[]`
		 */
		findGroupsFromTicketType: {
			id: '/pass/v2/ticket/groups',
			request: (
				query: {
					ticketTypes: string[];
				},
				params: RequestParams = {},
			) =>
				this.request<FindAllProductGroupsFromTicketTypeResultDto[], any>({
					path: `/pass/v2/ticket/groups`,
					method: 'GET',
					query: query,
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/ticket
		 * @name FindTicketTypeById
		 * @request GET:/pass/v2/ticket/type/{ticketTypeId}
		 * @response `200` `GetOneTicketTypesFullResultDto`
		 */
		findTicketTypeById: {
			id: '/pass/v2/ticket/type/${ticketTypeId}',
			request: (input: { ticketTypeId: string }, params: RequestParams = {}) =>
				this.request<GetOneTicketTypesFullResultDto, any>({
					path: `/pass/v2/ticket/type/${input.ticketTypeId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	v2Sector = {
		/**
		 * No description
		 *
		 * @tags v2/sector
		 * @name FindOne
		 * @request GET:/pass/v2/sector/{sectorId}
		 * @response `200` `FindOneSectorResultDto`
		 */
		findOne: {
			id: '/pass/v2/sector/${sectorId}',
			request: (input: { sectorId: string }, params: RequestParams = {}) =>
				this.request<FindOneSectorResultDto, any>({
					path: `/pass/v2/sector/${input.sectorId}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
	v2Order = {
		/**
		 * No description
		 *
		 * @tags v2/order
		 * @name GetOrderContents
		 * @request GET:/pass/v2/order/{orderId}/contents
		 * @response `200` `GetOrderContentsResultDto`
		 */
		getOrderContents: {
			id: '/pass/v2/order/${orderId}/contents',
			request: (input: { orderId: string }, params: RequestParams = {}) =>
				this.request<GetOrderContentsResultDto, any>({
					path: `/pass/v2/order/${input.orderId}/contents`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/order
		 * @name OrderCreditFromCode
		 * @request POST:/pass/v2/order/order-credit-from-code
		 * @response `201` `OrderCreateResultDto`
		 */
		orderCreditFromCode: {
			id: '/pass/v2/order/order-credit-from-code',
			request: (data: OrderCreateCreditFromCodeBodyDto, params: RequestParams = {}) =>
				this.request<OrderCreateResultDto, any>({
					path: `/pass/v2/order/order-credit-from-code`,
					method: 'POST',
					body: data,
					type: ContentType.Json,
					format: 'json',
					...params,
				}),
		},
	};
	v2Organizer = {
		/**
		 * No description
		 *
		 * @tags v2/organizer
		 * @name FindAllVisibleOrganizerSlugs
		 * @request GET:/pass/v2/organizer/visible-slugs
		 * @response `200` `(FindAllVisibleOrganizerSlugsResultDto)[]`
		 */
		findAllVisibleOrganizerSlugs: {
			id: '/pass/v2/organizer/visible-slugs',
			request: (params: RequestParams = {}) =>
				this.request<FindAllVisibleOrganizerSlugsResultDto[], any>({
					path: `/pass/v2/organizer/visible-slugs`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},

		/**
		 * No description
		 *
		 * @tags v2/organizer
		 * @name GetOrganizerBySlug
		 * @request GET:/pass/v2/organizer/slug/{slug}
		 * @response `200` `GetOrganizerBySlugResultDto`
		 */
		getOrganizerBySlug: {
			id: '/pass/v2/organizer/slug/${slug}',
			request: (input: { slug: string }, params: RequestParams = {}) =>
				this.request<GetOrganizerBySlugResultDto, any>({
					path: `/pass/v2/organizer/slug/${input.slug}`,
					method: 'GET',
					format: 'json',
					...params,
				}),
		},
	};
}
